import _ from "lodash";
import * as monaco from "monaco-editor";
import store from "../../../../../store";
// Monaco dil desteği ve otomatik tamamlama için tiplerini tanımlama
export const createCompletionItemProvider = (automationAttributes = [], moduleCache = []) => {
    const getFlatAttributes = () => {
        const flat = (attr, parentLabel = "") => {
            const label = parentLabel ? `${parentLabel} > ${attr.label}` : attr.label;
            attr.fullLabel = label;
            if (attr.subAttributes) {
                return [attr, ...attr.subAttributes.flatMap((x) => flat(x, attr.fullLabel))];
            }
            return [attr];
        };
        return automationAttributes.flatMap((x) => flat(x, undefined));
    };
    const flatAttributes = getFlatAttributes();
    return {
        provideCompletionItems: function (model, position) {
            const textUntilPosition = model.getValueInRange({
                startLineNumber: position.lineNumber,
                startColumn: 1,
                endLineNumber: position.lineNumber,
                endColumn: position.column,
            });

            const lastWordMatch = textUntilPosition.match(/[\w\d.$]+$/);
            const lastWord = lastWordMatch ? lastWordMatch[0] : "";

            // Verilen context için uygun öznitelikleri filtrele
            const getContextAttributes = (context) => {
                return flatAttributes
                    .filter((attr) => attr.context === context)
                    .map((attr) => ({
                        label: attr.fullLabel || attr.value,
                        kind: monaco.languages.CompletionItemKind.Variable,
                        insertText: attr.value,
                        detail: attr.fullLabel || attr.value,
                        documentation: `${attr.fullLabel || attr.value}\nTip: ${attr.valueType || "string"}`,
                    }));
            };

            // "block.", "contact.", "event." gibi prefixler için önerileri doğrudan göster
            if (lastWord) {
                console.log("createCompletionItemProvider-> lastWord", lastWord);
                const contextMatch = lastWord.match(/^(block|event|system|webhook|custom|contact)\./);
                if (contextMatch) {
                    const context = contextMatch[1];
                    const prefix = lastWord;

                    // Tekrarlanan önerileri filtreleme
                    const uniqueSuggestions = [];
                    const valueSet = new Set();

                    // Önce filtreleyip sonra tekrarları temizleyerek benzersiz öneriler oluştur
                    flatAttributes
                        .filter((attr) => attr.value.startsWith(prefix))
                        .forEach((attr) => {
                            // Prefixten sonraki kısmı al
                            const insertTextValue = attr.value.substring(prefix.length);

                            // Eğer bu değer daha önce eklenmemişse ekle
                            if (!valueSet.has(attr.value)) {
                                valueSet.add(attr.value);
                                uniqueSuggestions.push({
                                    label: attr.fullLabel || attr.value,
                                    kind: monaco.languages.CompletionItemKind.Variable,
                                    insertText: insertTextValue,
                                    detail: attr.value,
                                    documentation: `${attr.fullLabel || attr.value}\nTip: ${
                                        attr.valueType || "string"
                                    }`,
                                });
                            }
                        });

                    return {
                        suggestions: uniqueSuggestions,
                    };
                }

                // Supsis SDK AutoComplete
                const supsisMatch = lastWord.match(/^supsis\.?$/);
                console.log("createCompletionItemProvider-> supsisMatch", supsisMatch);
                if (supsisMatch) {
                    const modules = [
                        { label: "users", kind: monaco.languages.CompletionItemKind.Module, insertText: "users", detail: "Supsis Kullanıcı Modülü", documentation: "Kullanıcı işlemleri, widget, ses ve TTS için API modülü" },
                        { label: "ticket", kind: monaco.languages.CompletionItemKind.Module, insertText: "ticket", detail: "Supsis Bilet Modülü", documentation: "Bilet işlemleri için API modülü" },
                        { label: "task", kind: monaco.languages.CompletionItemKind.Module, insertText: "task", detail: "Supsis Görev Modülü", documentation: "Görev işlemleri için API modülü" },
                        { label: "contact", kind: monaco.languages.CompletionItemKind.Module, insertText: "contact", detail: "Supsis Kişi Modülü", documentation: "Kişi işlemleri için API modülü" },
                        { label: "activity", kind: monaco.languages.CompletionItemKind.Module, insertText: "activity", detail: "Supsis Aktivite Modülü", documentation: "Özel aktivite kayıtları oluşturma için API modülü" },
                        { label: "whatsapp", kind: monaco.languages.CompletionItemKind.Module, insertText: "whatsapp", detail: "Supsis WhatsApp Modülü", documentation: "WhatsApp işlemleri için API modülü" },
                        { label: "chat", kind: monaco.languages.CompletionItemKind.Module, insertText: "chat", detail: "Supsis Chat Modülü", documentation: "Chat işlemleri için API modülü" },
                        { label: "message", kind: monaco.languages.CompletionItemKind.Module, insertText: "message", detail: "Supsis Mesaj Modülü", documentation: "Mesaj işlemleri için API modülü" },
                        { label: "form", kind: monaco.languages.CompletionItemKind.Module, insertText: "form", detail: "Supsis Form Modülü", documentation: "Form işlemleri için API modülü" },
                        { label: "channel", kind: monaco.languages.CompletionItemKind.Module, insertText: "channel", detail: "Supsis Kanal Modülü", documentation: "Kanal işlemleri için API modülü" },
                        { label: "zoho", kind: monaco.languages.CompletionItemKind.Module, insertText: "zoho", detail: "Supsis Zoho CRM Modülü", documentation: "Zoho CRM entegrasyonu için API modülü" },
                        { label: "sms", kind: monaco.languages.CompletionItemKind.Module, insertText: "sms", detail: "Supsis SMS Modülü", documentation: "SMS gönderimi için API modülü" },
                        { label: "email", kind: monaco.languages.CompletionItemKind.Module, insertText: "email", detail: "Supsis Email Modülü", documentation: "Email gönderimi için API modülü" },
                        { label: "report", kind: monaco.languages.CompletionItemKind.Module, insertText: "report", detail: "Supsis Rapor Modülü", documentation: "Raporlama işlemleri için API modülü" },
                        { label: "module", kind: monaco.languages.CompletionItemKind.Module, insertText: "module", detail: "Supsis Modül Erişimi", documentation: "Modüller ve özel tablolar için API erişimi" },
                        { label: "asset", kind: monaco.languages.CompletionItemKind.Module, insertText: "asset", detail: "Supsis Asset Modülü", documentation: "Dosya ve medya yönetimi için API modülü" },
                        { label: "util", kind: monaco.languages.CompletionItemKind.Module, insertText: "util", detail: "Supsis Utility Modülü", documentation: "Yardımcı fonksiyonlar ve dönüştürme araçları için API modülü" },
                        { label: "balance", kind: monaco.languages.CompletionItemKind.Module, insertText: "balance", detail: "Supsis Bakiye Modülü", documentation: "Cüzdan bakiye işlemleri için API modülü" },
                        { label: "ikas", kind: monaco.languages.CompletionItemKind.Module, insertText: "ikas", detail: "Supsis İkas Modülü", documentation: "İkas e-ticaret platformu entegrasyonu için API modülü" },
                        { label: "voiceagent", kind: monaco.languages.CompletionItemKind.Module, insertText: "voiceagent", detail: "Supsis Voice Agent Modülü", documentation: "Yapay zeka destekli sesli arama işlemleri için API modülü" },
                        { label: "queue", kind: monaco.languages.CompletionItemKind.Module, insertText: "queue", detail: "Supsis Kuyruk Modülü", documentation: "İşlem kuyruğu yönetimi için API modülü" },
                        { label: "cache", kind: monaco.languages.CompletionItemKind.Module, insertText: "cache", detail: "Supsis Cache Modülü", documentation: "Otomasyon ve chatbot arası veri paylaşımı için cache yönetimi API modülü" },
                        { label: "youtube", kind: monaco.languages.CompletionItemKind.Module, insertText: "youtube", detail: "Supsis YouTube Modülü", documentation: "YouTube video ve yorum işlemleri için API modülü" },
                        { label: "googlebusiness", kind: monaco.languages.CompletionItemKind.Module, insertText: "googlebusiness", detail: "Supsis Google Business Modülü", documentation: "Google Business konum ve yorum işlemleri için API modülü" },
                        { label: "googleplay", kind: monaco.languages.CompletionItemKind.Module, insertText: "googleplay", detail: "Supsis Google Play Modülü", documentation: "Google Play uygulama ve yorum işlemleri için API modülü" },
                        { label: "appstore", kind: monaco.languages.CompletionItemKind.Module, insertText: "appstore", detail: "Supsis App Store Modülü", documentation: "App Store uygulama ve yorum işlemleri için API modülü" },
                        { label: "googledrive", kind: monaco.languages.CompletionItemKind.Module, insertText: "googledrive", detail: "Supsis Google Drive Modülü", documentation: "Google Drive dosya işlemleri için API modülü" },
                        { label: "pushover", kind: monaco.languages.CompletionItemKind.Module, insertText: "pushover", detail: "Supsis Pushover Modülü", documentation: "Pushover push notification işlemleri için API modülü" },
                        { label: "slack", kind: monaco.languages.CompletionItemKind.Module, insertText: "slack", detail: "Supsis Slack Modülü", documentation: "Slack mesajlaşma işlemleri için API modülü" },
                        { label: "ai", kind: monaco.languages.CompletionItemKind.Module, insertText: "ai", detail: "Supsis AI Modülü (OpenRouter)", documentation: "OpenRouter üzerinden çoklu LLM sağlayıcıları ile AI işlemleri için API modülü" },
                    ];
                    return { suggestions: modules };
                }

                // users. alt metodları
                const usersMatch = lastWord.match(/^supsis\.users\.?$/);
                console.log("createCompletionItemProvider-> usersMatch", usersMatch);
                if (usersMatch) {
                    return {
                        suggestions: [
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "get(${1:id})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kullanıcı bilgilerini getirir",
                                documentation: "Kullanıcı ID'sine göre kullanıcı bilgilerini getirir",
                            },
                            {
                                label: "list",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "list()",
                                detail: "Kullanıcı listesini döndürür",
                                documentation: "Sistemdeki tüm kullanıcıların listesini döndürür",
                            },
                            {
                                label: "showWidget",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'showWidget({\n\tuserId: "${1:userId}",\n\ttitle: "${2:Widget Başlığı}",\n\turl: "${3:https://example.com}",\n\tfullScreen: ${4:false},\n\tmode: "${5:url}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kullanıcıya widget gösterir",
                                documentation:
                                    "Panel kullanıcısına widget gösterir.\nParametreler:\n- userId: Kullanıcı ID'si (string, zorunlu)\n- title: Widget başlığı (string)\n- url: Widget URL'si (mode='url' için)\n- html: HTML içeriği (mode='html' için)\n- mode: 'url' veya 'html' (varsayılan: 'url')\n- fullScreen: Tam ekran göster (boolean)\n- sessionId: Oturum ID'si (opsiyonel)",
                            },
                            {
                                label: "playSound",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'playSound({\n\tuserId: "${1:userId}",\n\tsound: "${2:notification}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kullanıcıya ses çalar",
                                documentation:
                                    "Panel kullanıcısına ses çalar.\nParametreler:\n- userId: Kullanıcı ID'si (string, zorunlu)\n- sound: Hazır ses adı - 'beep', 'info', 'success', 'warning', 'error', 'notification' (varsayılan: 'notification')\n- url: Özel ses dosyası URL'si (opsiyonel)\n- sessionId: Oturum ID'si (opsiyonel)",
                            },
                            {
                                label: "playSpeechToText",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'playSpeechToText({\n\tuserId: "${1:userId}",\n\ttext: "${2:Okunacak metin}",\n\tlang: "${3:tr-TR}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kullanıcıya text'i sese çevirip çalar",
                                documentation:
                                    "Panel kullanıcısına verilen metni sese çevirip çalar (Text-to-Speech).\nParametreler:\n- userId: Kullanıcı ID'si (string, zorunlu)\n- text: Okunacak metin (string, zorunlu)\n- lang: Dil kodu - 'tr-TR', 'en-US' vb. (varsayılan: 'tr-TR')\n- sessionId: Oturum ID'si (opsiyonel)",
                            },
                        ],
                    };
                }

                // ticket. alt metodları
                const ticketMatch = lastWord.match(/^supsis\.ticket\.?$/);
                console.log("createCompletionItemProvider-> ticketMatch", ticketMatch);
                if (ticketMatch) {
                    return {
                        suggestions: [
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "get(${1:id})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Bilet detaylarını getirir",
                                documentation: "Bilet ID'sine göre bilet detaylarını getirir",
                            },
                            {
                                label: "create",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "create(${1:ticketId}, {\n\t${2:field}: ${3:value}\n})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Bilet günceller",
                                documentation: "Var olan bir bileti belirtilen alan değerleriyle günceller",
                            },
                            {
                                label: "update",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "update(${1:ticketId}, {\n\t${2:field}: ${3:value}\n})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Bilet günceller",
                                documentation: "Var olan bir bileti belirtilen alan değerleriyle günceller",
                            },
                        ],
                    };
                }

                // task. alt metodları
                const taskMatch = lastWord.match(/^supsis\.task\.?$/);
                console.log("createCompletionItemProvider-> taskMatch", taskMatch);
                if (taskMatch) {
                    return {
                        suggestions: [
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "get(${1:id})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Görev detaylarını getirir",
                                documentation: "Görev ID'sine göre görev detaylarını getirir",
                            },
                            {
                                label: "create",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'create({\n  workflowId: "workflowId",\n  pipelineStageId: "pipelineStageId",\n  title: "Görev Başlığı",\n  description: "Açıklama",\n  priority: "medium",\n  assigneeIds: ["userId1"],\n  followerIds: ["userId2"],\n  collaboratorIds: ["userId3"],\n  ownerId: "ownerId",\n  tags: ["tagId1"],\n  checklist: [],\n  startDate: "2025-05-12T12:15:38.879Z",\n  endDate: "2025-05-12T12:15:38.879Z",\n  relations: [],\n  attachments: [],\n  subTasks: []\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yeni görev oluşturur",
                                documentation: `Zorunlu alanlar: workflowId, pipelineStageId, title.\nDiğer parametreler opsiyoneldir: description, priority (low,lowest,medium,high,highest), assigneeIds, followerIds, collaboratorIds, ownerId, tags, checklist, startDate (unix timestamp), endDate (unix timestamp), relations, attachments, subTasks.\nÖrnek: create({\\n  workflowId: \"workflowId\",\\n  pipelineStageId: \"pipelineStageId\",\\n  title: \"Görev Başlığı\",\\n  startDate: "2025-05-12T12:15:38.879Z",\\n  endDate: "2025-05-12T12:15:38.879Z"\\n})`,
                            },
                            {
                                label: "update",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "update(${1:taskId}, {\n\t${2:field}: ${3:value}\n})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Görev günceller",
                                documentation: "Var olan bir görevi belirtilen alan değerleriyle günceller",
                            },
                            {
                                label: "move",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "move(${1:taskId}, ${2:pipelineName})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Görevi başka bir pipeline'a taşır",
                                documentation:
                                    "Belirtilen taskId'li görevi, pipelineName ile belirtilen pipeline'a taşır.",
                            },
                            {
                                label: "search",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'search(${1:workflowId}, {\n  pipelineId: "pipelineId",\n  assignees: ["userId1"],\n  showOverdue: false,\n  search: "arama kelimesi",\n  priorities: ["high"],\n  owner: "ownerId",\n  followers: ["userId2"],\n  dateRange: ["2024-01-01","2024-01-31"],\n  createdBy: ["userId3"],\n  tags: ["tagId1"],\n  startDateRange: ["2025-05-12T12:15:38.879Z","2025-05-12T12:15:38.879Z"],\n  endDateRange: ["2024-01-01","2024-01-31"]\n}, {\n  page: 1,\n  perPage: 10\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Görev araması yapar",
                                documentation: `workflowId (zorunlu), filters (opsiyonel obje), cursor (opsiyonel obje) ile görev araması yapar.\nfilters: { pipelineId, assignees, showOverdue, search, priorities, owner, followers, dateRange, createdBy, tags, startDateRange, endDateRange }\ncursor: { page, perPage }\nÖrnek: search(\"workflowId\", { pipelineId: \"pipelineId\", assignees: [\"userId1\"] }, { page: 1, perPage: 10 })`,
                            },
                        ],
                    };
                }

                // contact. alt metodları
                const contactMatch = lastWord.match(/^supsis\.contact\.?$/);
                console.log("createCompletionItemProvider-> contactMatch", contactMatch);
                if (contactMatch) {
                    return {
                        suggestions: [
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "get(${1:id})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kişi detaylarını getirir",
                                documentation: "Kişi ID'sine göre kişi detaylarını getirir",
                            },
                            {
                                label: "create",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'create({\n\tplatform: ${1:"supsis"},\n\tfullname: ${2:"Ad Soyad"},\n\temail: ${3:"email@example.com"},\n\tphone: ${4:"5551234567"},\n\tchannelIds: ${5:[]},\n\tcontactProperties: ${6:{}}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yeni kişi oluşturur",
                                documentation:
                                    "Yeni bir kişi kaydı oluşturur. Platform supsis|whatsapp|email olmalıdır. WhatsApp için phone ve channelIds, email için email zorunludur.",
                            },
                            {
                                label: "update",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "update(${1:contactId}, {\n\t${2:field}: ${3:value}\n})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kişi standart alanlarını günceller",
                                documentation:
                                    "Var olan bir kişinin standart alanlarını günceller (ör: fullname, email, phone vb.)",
                            },
                            {
                                label: "addTag",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "addTag(${1:contactId}, ${2:tagId})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kişiye etiket ekler",
                                documentation: "Belirtilen kişiye (contactId) bir etiket (tagId) ekler.",
                            },
                            {
                                label: "removeTag",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "removeTag(${1:contactId}, ${2:tagId})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kişiden etiket çıkarır",
                                documentation: "Belirtilen kişiden (contactId) bir etiket (tagId) çıkarır.",
                            },
                            {
                                label: "updateContactProperty",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "updateContactProperty(${1:contactId}, ${2:propertyName}, ${3:value})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kişi özel alanını günceller",
                                documentation:
                                    "Bir kişinin özel bir contact property (propertyName) alanını günceller.",
                            },
                            {
                                label: "changeOwnerAuto",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'changeOwnerAuto(${1:contactId}, {\n\tcheckOnlineStatus: ${2:false},\n\talgorithm: "${3:least_contact}",\n\tdateRange: "${4:today}",\n\texcludeUserIds: ${5:[]}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kişi sahipliğini otomatik algoritma ile değiştirir",
                                documentation:
                                    "Kişi sahipliğini otomatik algoritma ile değiştirir. Algorithm: 'least_contact' (en az contact'a sahip) veya 'random'. DateRange: 'today', 'last_7_days', 'last_30_days'.",
                            },
                            {
                                label: "changeOwner",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "changeOwner(${1:contactId}, ${2:ownerId})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kişi sahipliğini belirli bir kullanıcıya değiştirir",
                                documentation:
                                    "Kişi sahipliğini belirtilen kullanıcı ID'sine (ownerId) değiştirir.",
                            },
                            {
                                label: "search",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'search({\n\toperator: "${1:and}",\n\tgroups: [\n\t\t{\n\t\t\toperator: "${2:and}",\n\t\t\tfilters: [\n\t\t\t\t{\n\t\t\t\t\trule: "${3:contains}",\n\t\t\t\t\tattribute: "${4:fullname}",\n\t\t\t\t\tvalue: "${5:search_value}"\n\t\t\t\t}\n\t\t\t]\n\t\t}\n\t]\n}, {\n\toffset: ${6:0},\n\tlimit: ${7:10}\n}, ${8:[]}, ${9:false})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kişileri filtreleme gruplarına göre arar",
                                documentation:
                                    "Kişileri gelişmiş filtreleme gruplarına göre arar ve listeler.\nParametreler:\n- filterGroups: Filtreleme grupları objesi (zorunlu)\n- cursor: Sayfalama bilgisi (opsiyonel) - { offset, limit }\n- projectionFields: Dönüş alanları dizisi (opsiyonel)\n- withCount: Toplam kayıt sayısını döndür (opsiyonel, varsayılan: false) - true yapılırsa count alanı dolar, performansı etkiler\n\nKullanılabilir rule değerleri: equal, not_equal, contains, not_contains, starts_with, ends_with, empty, not_empty, is_one_of, greater_than, less_than\n\nKullanılabilir attribute değerleri: _id, fullname, email, phone, platform, tags._id, contactProperties.propertyName, owner vb.\n\nÖrnek: search({ operator: 'and', groups: [{ operator: 'and', filters: [{ rule: 'contains', attribute: 'fullname', value: 'Ahmet' }] }] }, { offset: 0, limit: 20 }, [], true)",
                            },
                            {
                                label: "getMessages",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "getMessages(${1:contactId}, { limit: ${2:20}, offset: ${3:0} })",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kişinin mesajlarını getirir",
                                documentation:
                                    "Kişinin tüm mesajlarını sayfalı olarak getirir.\nParametreler:\n- contactId: Kişi ID'si (string, zorunlu)\n- options: { limit, offset } (opsiyonel)\nDönüş: { data, totalPage, totalCount, offset, limit }",
                            },
                            {
                                label: "getChats",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "getChats(${1:contactId}, { page: ${2:1}, pageSize: ${3:10} })",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kişinin chat'lerini getirir",
                                documentation:
                                    "Kişinin tüm chat geçmişini sayfalı olarak getirir.\nParametreler:\n- contactId: Kişi ID'si (string, zorunlu)\n- options: { page, pageSize } (opsiyonel)\nDönüş: { conversations, totalCount, currentPage, pageSize }",
                            },
                        ],
                    };
                }

                // activity. alt metodları
                const activityMatch = lastWord.match(/^supsis\.activity\.?$/);
                console.log("createCompletionItemProvider-> activityMatch", activityMatch);
                if (activityMatch) {
                    return {
                        suggestions: [
                            {
                                label: "create",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'create({\n\tmessage: "${1:Özel aktivite mesajı}",\n\tnotification: {\n\t\tusers: [\n\t\t\t{\n\t\t\t\tid: "${2:userId}",\n\t\t\t\tconfig: { web: ${3:false}, email: ${4:true}, mobile: ${5:false} }\n\t\t\t}\n\t\t],\n\t\tconfig: { web: ${6:true}, email: ${7:true}, mobile: ${8:false} }\n\t},\n\tactions: [\n\t\t{\n\t\t\taction: "${9:view_record}",\n\t\t\tpayload: {\n\t\t\t\ttitle: "${10:Kayıt Başlığı}",\n\t\t\t\ttableId: "${11:tableId}",\n\t\t\t\trecordId: "${12:recordId}"\n\t\t\t}\n\t\t},\n\t\t{\n\t\t\taction: "${13:open-widget}",\n\t\t\tpayload: {\n\t\t\t\ttitle: "${14:Widget Başlığı}",\n\t\t\t\turl: "${15:https://example.com}",\n\t\t\t\tfullScreen: ${16:false},\n\t\t\t\tmode: "${17:url}",\n\t\t\t\thtml: "${18:}",\n\t\t\t\tusers: ["${19:userId1}"]\n\t\t\t}\n\t\t}\n\t],\n\tactorUserId: "${20:userId}",\n\tmetadata: {\n\t\t${21:source}: "${22:automation}",\n\t\t${23:customField}: "${24:değer}",\n\t\t${25:timestamp}: ${26:Date.now()}\n\t}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Özel aktivite kaydı oluşturur",
                                documentation:
                                    "Sistem aktivite kayıtlarında özel bir aktivite oluşturur.\nParametreler:\n- message: Aktivite mesajı (string, zorunlu)\n- notification: Bildirim ayarları (object, zorunlu)\n  - users: Kullanıcı özel ayarları (array)\n    - id: Kullanıcı ID (string)\n    - config: Kullanıcıya özel bildirim ayarları (object)\n      - web: Web bildirimi (boolean)\n      - email: Email bildirimi (boolean)\n      - mobile: Mobil bildirimi (boolean)\n  - config: Genel bildirim ayarları (object)\n    - web: Web bildirimi (boolean)\n    - email: Email bildirimi (boolean)\n    - mobile: Mobil bildirimi (boolean)\n- actions: Aktivite aksiyonları (array, opsiyonel)\n  - action: Aksiyon tipi (string) - 'close-supsis-external-widget', 'open_url_in_new_tab', 'view_record', 'start_chat', 'create_task', 'show_contact', 'show_message', 'make_call', 'open-widget'\n  - payload: Aksiyon verileri (object)\n    • close-supsis-external-widget: Payload gerekmez\n    • open_url_in_new_tab: { url }\n    • view_record: { title, tableId, recordId, multiple?, autoClose? }\n    • start_chat: { phoneNumber, close? }\n    • create_task: Payload gerekmez\n    • show_contact: { title, contactId }\n    • show_message: { notificationType, message, description? }\n    • make_call: { phoneNumber, close? }\n    • open-widget: { title, url?, fullScreen?, mode?, html?, users? }\n- actorUserId: Aktiviteyi yapan kullanıcı ID'si (string, opsiyonel) - Belirtilirse aktivite bu kullanıcı tarafından yapılmış gibi görünür, belirtilmezse sistem tarafından yapılmış olur\n- metadata: Ek veri objesi (object, opsiyonel) - Aktivite ile birlikte saklanacak özel veriler\n\nDönen değer: Oluşturulan aktivite objesi",
                            },
                        ],
                    };
                }

                // whatsapp. alt metodları
                const whatsappMatch = lastWord.match(/^supsis\.whatsapp\.?$/);
                console.log("createCompletionItemProvider-> whatsappMatch", whatsappMatch);
                if (whatsappMatch) {
                    return {
                        suggestions: [
                            {
                                label: "sendTemplateMessage",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'sendTemplateMessage({\n\tchannelId: ${1:"kanalId"},\n\ttemplate: ${2:templateObj},\n\tphoneNumber: ${3:"905xxxxxxxxx"},\n\tparams: ${4:["param1", "param2"]},\n\tasset: ${5:null}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "WhatsApp şablon mesajı gönderir",
                                documentation:
                                    "Bir WhatsApp kanalından şablon mesajı gönderir.\nParametreler:\n- channelId: Kanal ID\n- template: Şablon nesnesi veya ID\n- phoneNumber: Alıcı telefon numarası (ülke kodlu)\n- params: Şablon parametreleri (dizi)\n- asset: (opsiyonel) Medya/ek dosya objesi\nDönen değer: API yanıtı",
                            },
                            {
                                label: "getTemplate",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'getTemplate({\n\tchannelId: ${1:"kanalId"},\n\ttemplateId: ${2:"templateId"}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "WhatsApp şablon bilgisini getirir",
                                documentation:
                                    "Bir WhatsApp kanalında, ID'si bilinen şablonun detaylarını getirir.\nParametreler:\n- channelId: Kanal ID\n- templateId: Şablon ID\nDönen değer: Şablon nesnesi",
                            },
                            {
                                label: "qr",
                                kind: monaco.languages.CompletionItemKind.Module,
                                insertText: "qr",
                                detail: "WhatsApp QR alt modülü",
                                documentation: "WhatsApp QR kanalı üzerinden mesaj göndermek için kullanılır"
                            }
                        ],
                    };
                }

                // whatsapp.qr. alt metodları
                const whatsappQRMatch = lastWord.match(/^supsis\.whatsapp\.qr\.?$/);
                if (whatsappQRMatch) {
                    return {
                        suggestions: [
                            {
                                label: "send",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'send({\n\tchannelId: ${1:"whatsappQRKanalId"},\n\tphoneNumber: ${2:"905xxxxxxxxx"},\n\twhatsappId: ${3:"xxxxxxxxxxxx"},\n\tmessage: ${4:"Merhaba, bu bir test mesajıdır."},\n\tasset: ${5:null}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "WhatsApp QR üzerinden mesaj gönderir",
                                documentation:
                                    "WhatsApp QR kanalından standart mesaj gönderir ve otomatik olarak bir ghost chat oluşturur.",
                            },
                            {
                                label: "sendLocation",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'sendLocation({\n\tchannelId: ${1:"whatsappQRKanalId"},\n\tphoneNumber: ${2:"905xxxxxxxxx"},\n\tlocation: { lat: ${3:41.0082}, lng: ${4:28.9784} },\n\tcreateGhostChat: ${5:false}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "WhatsApp QR üzerinden konum mesajı gönderir",
                                documentation:
                                    "WhatsApp QR kanalından konum mesajı gönderir ve otomatik olarak bir ghost chat oluşturur.",
                            }
                        ]
                    };
                }

                // chat. alt metodları
                const chatMatch = lastWord.match(/^supsis\.chat\.?$/);
                if (chatMatch) {
                    return {
                        suggestions: [
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "get(${1:chatId})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Chat (sohbet) kaydını getirir",
                                documentation:
                                    "Chat ID'sine göre sohbet kaydını getirir. Parametre: chatId (string). Dönüş: Chat objesi.",
                            },
                            {
                                label: "close",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'close("${1:chatId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Chat'i kapatır (destroy eder)",
                                documentation:
                                    "Aktif bir chat'i kapatır.\nParametreler:\n- chatId: Chat ID'si (string, zorunlu)\nDönüş: { success: boolean, chatId: string, message: string }\n\nNot: Sadece new, chatbot, active veya lost durumundaki chatler kapatılabilir. Kapalı ve private chatler üzerinde bu işlem yapılamaz.",
                            },
                            {
                                label: "transferToQueue",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'transferToQueue("${1:chatId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Chat'i kuyruğa transfer eder",
                                documentation:
                                    "Aktif bir chat'i genel kuyruğa transfer eder.\nParametreler:\n- chatId: Chat ID'si (string, zorunlu)\nDönüş: { success: boolean, chatId: string, message: string }\n\nNot: Sadece new, chatbot, active veya lost durumundaki chatler transfer edilebilir.",
                            },
                            {
                                label: "transferToChatbot",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'transferToChatbot("${1:chatId}", {\n\tstoryId: "${2:storyId}",\n\tinitialBlockId: "${3:blockId}",\n\tpredefinedAttributes: {}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Chat'i chatbot'a transfer eder",
                                documentation:
                                    "Aktif bir chat'i chatbot'a transfer eder.\nParametreler:\n- chatId: Chat ID'si (string, zorunlu)\n- options: Transfer seçenekleri (object, opsiyonel)\n  - storyId: Chatbot story ID'si (string, opsiyonel - belirtilmezse kanal ayarlarından alınır)\n  - initialBlockId: Başlangıç block ID'si (string, opsiyonel)\n  - predefinedAttributes: Önceden tanımlı değişkenler (object, opsiyonel)\nDönüş: { success: boolean, chatId: string, message: string }\n\nNot: Sadece new, chatbot, active veya lost durumundaki chatler transfer edilebilir.",
                            },
                            {
                                label: "transferToDepartment",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'transferToDepartment("${1:chatId}", "${2:departmentId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Chat'i departmana transfer eder",
                                documentation:
                                    "Aktif bir chat'i belirtilen departmana transfer eder.\nParametreler:\n- chatId: Chat ID'si (string, zorunlu)\n- departmentId: Departman ID'si (string, zorunlu)\nDönüş: { success: boolean, chatId: string, departmentId: string, message: string }\n\nNot: Sadece new, chatbot, active veya lost durumundaki chatler transfer edilebilir.",
                            },
                            {
                                label: "transferToDepartmentAndAgent",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'transferToDepartmentAndAgent("${1:chatId}", "${2:departmentId}", "${3:agentId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Chat'i departman ve ajana transfer eder",
                                documentation:
                                    "Aktif bir chat'i belirtilen departman ve ajana transfer eder.\nParametreler:\n- chatId: Chat ID'si (string, zorunlu)\n- departmentId: Departman ID'si (string, zorunlu)\n- agentId: Ajan (kullanıcı) ID'si (string, zorunlu)\nDönüş: { success: boolean, chatId: string, departmentId: string, agentId: string, message: string }\n\nNot: Sadece new, chatbot, active veya lost durumundaki chatler transfer edilebilir.",
                            },
                            {
                                label: "getMessages",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "getMessages(${1:chatId})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Chat mesajlarını getirir",
                                documentation:
                                    "Chat'teki tüm mesajları getirir.\nParametreler:\n- chatId: Chat ID'si (string, zorunlu)\nDönüş: Mesaj dizisi",
                            },
                        ],
                    };
                }

                // message. alt metodları
                const messageMatch = lastWord.match(/^supsis\.message\.?$/);
                if (messageMatch) {
                    return {
                        suggestions: [
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "get(${1:messageId})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Mesaj kaydını getirir",
                                documentation:
                                    "Message ID'sine göre mesaj kaydını getirir. Parametre: messageId (string). Dönüş: Mesaj objesi.",
                            },
                            {
                                label: "findByExternalProviderId",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "findByExternalProviderId(${1:externalProviderId})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "External Provider ID ile mesaj bulur",
                                documentation:
                                    "External Provider ID'sine göre mesaj arar ve bulursa tam mesaj detaylarını getirir. Parametre: externalProviderId (string). Dönüş: Mesaj objesi veya null.",
                            },
                            {
                                label: "findByGupshupMessageId",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "findByGupshupMessageId(${1:gupshupMessageId})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Gupshup Message ID ile mesaj bulur",
                                documentation:
                                    "Gupshup Message ID'sine göre mesaj arar ve bulursa tam mesaj detaylarını getirir. Parametre: gupshupMessageId (string). Dönüş: Mesaj objesi veya null.",
                            },
                            {
                                label: "findByMetaMessageId",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "findByMetaMessageId(${1:metaMessageId})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Meta Message ID ile mesaj bulur",
                                documentation:
                                    "Meta (Facebook/WhatsApp) Message ID'sine göre mesaj arar ve bulursa tam mesaj detaylarını getirir. Parametre: metaMessageId (string). Dönüş: Mesaj objesi veya null.",
                            },
                            {
                                label: "findByUniqMessageId",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "findByUniqMessageId(${1:uniqMessageId})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Unique Message ID ile mesaj bulur",
                                documentation:
                                    "Unique Message ID'sine göre mesaj arar ve bulursa tam mesaj detaylarını getirir. Parametre: uniqMessageId (string). Dönüş: Mesaj objesi veya null.",
                            },
                            {
                                label: "toLite",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "toLite(${1:message})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Mesajı basit formata çevirir",
                                documentation:
                                    "Mesaj objesini basitleştirilmiş formata dönüştürür.\nDönüş: { _id, createdDate, messageType, description, caption, sender, hasAsset, assetUrl, conversationId, visitorId, userId }",
                            },
                            {
                                label: "toLLM",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "toLLM(${1:messageOrMessages})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Mesajı LLM formatına çevirir",
                                documentation:
                                    "Mesaj veya mesaj dizisini LLM'in anlayacağı formata dönüştürür. Sistem mesajları filtrelenir, sadece insan mesajları kalır.\nDönüş: { _id, timestamp, sender, direction, content, type, agentName }",
                            },
                        ],
                    };
                }

                // form. alt metodları
                const formMatch = lastWord.match(/^supsis\.form\.?$/);
                if (formMatch) {
                    return {
                        suggestions: [
                            {
                                label: "getSubmission",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getSubmission("${1:submission-id}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Form submission kaydını basit formatta getirir",
                                documentation:
                                    "Form submission ID'sine göre form cevaplarını basit formatta getirir.\nParametreler:\n- submissionId: Form submission ID'si (string, zorunlu)\nDönüş: { fieldSlug1: value1, fieldSlug2: value2, ... } - Form field slug'larını key, cevapları value olarak içeren obje\n\nÖrnek kullanım:\nconst answers = await supsis.form.getSubmission('submission-id-123');\nconsole.log(answers.customer_name); // Form field'ının slug'ı 'customer_name' ise",
                            },
                        ],
                    };
                }

                // sms. alt metodları
                const smsMatch = lastWord.match(/^supsis\.sms\.?$/);
                console.log("createCompletionItemProvider-> smsMatch", smsMatch);
                if (smsMatch) {
                    return {
                        suggestions: [
                            {
                                label: "send",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'send({\n  channelId: "${1:kanalId}",\n  senderId: "${2:gonderenId}",\n  number: "${3:905xxxxxxxxx}",\n  message: "${4:Mesajınız}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "SMS gönderir",
                                documentation:
                                    "Bir SMS kanalından belirtilen numaraya mesaj gönderir. Parametreler: channelId, senderId, number, message. Dönüş: API yanıtı.",
                            },
                        ],
                    };
                }

                // email. alt metodları
                const emailMatch = lastWord.match(/^supsis\.email\.?$/);
                console.log("createCompletionItemProvider-> emailMatch", emailMatch);
                if (emailMatch) {
                    return {
                        suggestions: [
                            {
                                label: "getByMailId",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getByMailId("${1:mailId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Mail _id ile mail detayını getirir",
                                documentation:
                                    "Mail kaydının _id değeri ile detayını getirir. Dönüş: Mail objesi (sender, to_list, subject, body_text vb.) veya null. Örn: event.email.delivered.mailId ile kullanılabilir.",
                            },
                            {
                                label: "send",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'send({\n  from: "${1:destek@sirket.com}",\n  to: "${2:musteri@ornek.com}",\n  subject: "${3:Konu}",\n  content: "${4:İçerik}",\n  senderName: "${5:Gönderen Adı}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Email gönderir",
                                documentation:
                                    "Bir email kanalından belirtilen adrese email gönderir. Parametreler: from, to, subject, content, senderName, templateId, type. Dönüş: API yanıtı.",
                            },
                        ],
                    };
                }

                // pushover. alt metodları
                const pushoverMatch = lastWord.match(/^supsis\.pushover\.?$/);
                console.log("createCompletionItemProvider-> pushoverMatch", pushoverMatch);
                if (pushoverMatch) {
                    return {
                        suggestions: [
                            {
                                label: "send",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'send({\n  channelId: "${1:pushover-channel-id}",\n  message: "${2:Bildirim mesajı}",\n  title: "${3:Bildirim Başlığı}",\n  priority: ${4:0},\n  sound: "${5:pushover}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Pushover bildirimi gönderir",
                                documentation:
                                    "Pushover kanalı üzerinden push notification gönderir.\nParametreler:\n- channelId: Pushover kanal ID'si (zorunlu)\n- message: Bildirim mesajı (zorunlu)\n- title: Bildirim başlığı (opsiyonel)\n- priority: Öncelik -2 ile 2 arası (varsayılan: 0)\n- sound: Bildirim sesi (pushover, bike, bugle, cashregister, classical, cosmic, falling, gamelan, incoming, intermission, magic, mechanical, pianobar, siren, spacealarm, tugboat, alien, climb, persistent, echo, updown, vibrate, none)\n- url: Bildirime eklenecek URL\n- urlTitle: URL başlığı\n- device: Hedef cihaz adı\nDönüş: { success: boolean, message: string, request: string }",
                            },
                        ],
                    };
                }

                // slack. alt metodları
                const slackMatch = lastWord.match(/^supsis\.slack\.?$/);
                console.log("createCompletionItemProvider-> slackMatch", slackMatch);
                if (slackMatch) {
                    return {
                        suggestions: [
                            {
                                label: "sendMessage",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'sendMessage({\n  channelId: "${1:slack-channel-id}",\n  message: "${2:Mesaj içeriği}",\n  channel: "${3:#general}",\n  username: "${4:Supsis Bot}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Slack'e mesaj gönderir",
                                documentation:
                                    "Slack kanalına mesaj gönderir.\nParametreler:\n- channelId: Slack IntegrationChannel ID'si (zorunlu)\n- message: Mesaj içeriği (zorunlu)\n- channel: Hedef Slack kanalı (ör: #general)\n- username: Bot kullanıcı adı\n- iconEmoji: Bot ikonu (ör: :robot_face:)\nDönüş: { success: boolean, message: string }",
                            },
                            {
                                label: "sendWithBlocks",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'sendWithBlocks({\n  channelId: "${1:slack-channel-id}",\n  blocks: [\n    {\n      type: "section",\n      text: {\n        type: "mrkdwn",\n        text: "${2:*Başlık*\\nİçerik}"\n      }\n    }\n  ],\n  text: "${3:Fallback text}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Slack'e Block Kit formatında mesaj gönderir",
                                documentation:
                                    "Slack Block Kit kullanarak zengin içerikli mesaj gönderir.\nParametreler:\n- channelId: Slack IntegrationChannel ID'si (zorunlu)\n- blocks: Slack Block Kit blocks dizisi (zorunlu)\n- channel: Hedef Slack kanalı (opsiyonel)\n- text: Fallback text (bildirimler için)\nDönüş: { success: boolean, message: string }",
                            },
                            {
                                label: "sendWithAttachment",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'sendWithAttachment({\n  channelId: "${1:slack-channel-id}",\n  attachment: {\n    color: "${2:#36a64f}",\n    title: "${3:Başlık}",\n    text: "${4:İçerik}",\n    footer: "${5:Alt bilgi}"\n  }\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Slack'e attachment formatında mesaj gönderir",
                                documentation:
                                    "Slack attachment formatında mesaj gönderir.\nParametreler:\n- channelId: Slack IntegrationChannel ID'si (zorunlu)\n- attachment: Slack attachment objesi (zorunlu)\n  - color: Attachment rengi (ör: #36a64f, good, warning, danger)\n  - pretext: Attachment öncesi metin\n  - title: Başlık\n  - titleLink: Başlık linki\n  - text: İçerik\n  - fields: Alanlar [{title, value, short}]\n  - footer: Alt bilgi\n- channel: Hedef Slack kanalı (opsiyonel)\nDönüş: { success: boolean, message: string }",
                            },
                        ],
                    };
                }

                // googledrive. alt metodları
                const googledriveMatch = lastWord.match(/^supsis\.googledrive\.?$/);
                console.log("createCompletionItemProvider-> googledriveMatch", googledriveMatch);
                if (googledriveMatch) {
                    return {
                        suggestions: [
                            {
                                label: "search",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'search("${1:channelId}", "${2:arama terimi}", {\n  folderId: ${3:null},\n  pageSize: ${4:50}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Google Drive'da dosya arar",
                                documentation:
                                    "Google Drive'da dosya arar.\nParametreler:\n- channelId: Google Drive kanal ID'si (zorunlu)\n- query: Arama sorgusu (zorunlu)\n- options: { folderId, pageSize, pageToken } (opsiyonel)\nDönüş: { files: File[], nextPageToken }",
                            },
                            {
                                label: "list",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'list("${1:channelId}", {\n  folderId: ${2:null},\n  driveId: ${3:null},\n  pageSize: ${4:50}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Google Drive dosyalarını listeler",
                                documentation:
                                    "Google Drive'dan dosyaları listeler.\nParametreler:\n- channelId: Google Drive kanal ID'si (zorunlu)\n- options: { folderId, driveId, pageSize, pageToken } (opsiyonel)\nDönüş: { files: File[], nextPageToken }",
                            },
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'get("${1:channelId}", "${2:fileId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Google Drive dosya bilgisini getirir",
                                documentation:
                                    "Google Drive dosya bilgisini getirir.\nParametreler:\n- channelId: Google Drive kanal ID'si (zorunlu)\n- fileId: Dosya ID'si (zorunlu)\nDönüş: File objesi { id, name, mimeType, size, createdTime, modifiedTime, webViewLink, ... }",
                            },
                            {
                                label: "uploadByAsset",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'uploadByAsset("${1:channelId}", "${2:assetId}", {\n  folderId: ${3:null},\n  fileName: ${4:null}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Supsis Asset'ini Google Drive'a yükler",
                                documentation:
                                    "Supsis Asset'ini Google Drive'a yükler.\nParametreler:\n- channelId: Google Drive kanal ID'si (zorunlu)\n- assetId: Supsis Asset ID'si (zorunlu)\n- options: { folderId, fileName } (opsiyonel)\nDönüş: Yüklenen dosya objesi",
                            },
                            {
                                label: "downloadAsAsset",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'downloadAsAsset("${1:channelId}", "${2:fileId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Google Drive dosyasını indirir ve Asset oluşturur",
                                documentation:
                                    "Google Drive dosyasını indirir ve Supsis Asset oluşturur.\nParametreler:\n- channelId: Google Drive kanal ID'si (zorunlu)\n- fileId: Dosya ID'si (zorunlu)\nDönüş: Asset objesi { _id, path, ... }",
                            },
                            {
                                label: "deleteFile",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'deleteFile("${1:channelId}", "${2:fileId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Google Drive dosyasını siler",
                                documentation:
                                    "Google Drive dosyasını siler.\nParametreler:\n- channelId: Google Drive kanal ID'si (zorunlu)\n- fileId: Dosya ID'si (zorunlu)\nDönüş: { success: boolean }",
                            },
                        ],
                    };
                }

                // ai. alt metodları (OpenRouter)
                const aiMatch = lastWord.match(/^supsis\.ai\.?$/);
                console.log("createCompletionItemProvider-> aiMatch", aiMatch);
                if (aiMatch) {
                    return {
                        suggestions: [
                            {
                                label: "createResponse",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'createResponse({\n  model: "${1:google/gemini-2.0-flash-001}",\n  input: "${2:Merhaba, nasılsın?}",\n  instructions: "${3:Sen yardımcı bir asistansın}",\n  temperature: ${4:0.7},\n  maxTokens: ${5:1000}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "OpenRouter API ile AI cevabı oluşturur",
                                documentation:
                                    "OpenRouter API kullanarak AI cevabı oluşturur.\nParametreler:\n- model: Model identifier (zorunlu) - Örn: 'google/gemini-2.0-flash-001', 'openai/gpt-4o', 'anthropic/claude-3.5-sonnet'\n- input: Giriş metni veya mesaj (zorunlu)\n- instructions: Sistem talimatları (opsiyonel)\n- temperature: Sıcaklık 0-2 arası (opsiyonel, varsayılan: 0.7)\n- maxTokens: Maksimum token sayısı (opsiyonel)\n- channelId: OpenRouter kanal ID'si (opsiyonel, otomatik bulunur)\nDönüş: { success, id, model, output, output_text, usage }",
                            },
                        ],
                    };
                }

                // channel. alt metodları
                const channelMatch = lastWord.match(/^supsis\.channel\.?$/);
                console.log("createCompletionItemProvider-> channelMatch", channelMatch);
                if (channelMatch) {
                    return {
                        suggestions: [
                            {
                                label: "list",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "list()",
                                detail: "Tüm kanalları listeler",
                                documentation: "Sistemdeki tüm erişilebilir kanalların listesini döndürür. Dönüş: Kanal dizisi",
                            },
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'get("${1:channelId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Belirli bir kanalın detaylarını getirir",
                                documentation: "Kanal ID'sine göre kanal detaylarını getirir. Parametre: channelId (string). Dönüş: Kanal objesi veya null",
                            },
                            {
                                label: "getByType",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getByType("${1:whatsapp-business-api}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Belirli tipte kanalları listeler",
                                documentation: "Kanal tipine göre kanalları filtreler. Parametre: type (string) - örn: 'whatsapp-business-api', 'webchat', 'sms-postacell'. Dönüş: Kanal dizisi",
                            },
                        ],
                    };
                }

                // zoho. alt metodları
                const zohoMatch = lastWord.match(/^supsis\.zoho\.?$/);
                console.log("createCompletionItemProvider-> zohoMatch", zohoMatch);
                if (zohoMatch) {
                    return {
                        suggestions: [
                            {
                                label: "getDealsByPhone",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getDealsByPhone("${1:905551234567}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Telefon numarasına göre anlaşmaları getirir",
                                documentation: "Zoho CRM'de telefon numarasına göre anlaşmaları arar ve getirir. Parametre: phone (string)",
                            },
                            {
                                label: "getUserById",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getUserById("${1:userId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kullanıcı ID'sine göre kullanıcı bilgilerini getirir",
                                documentation: "Zoho CRM'de kullanıcı ID'sine göre kullanıcı detaylarını getirir. Parametre: userId (string)",
                            },
                            {
                                label: "getAllUsers",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "getAllUsers()",
                                detail: "Tüm Zoho kullanıcılarını listeler",
                                documentation: "Zoho CRM'deki tüm kullanıcıları listeler. Parametre yok.",
                            },
                            {
                                label: "getContactByPhone",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getContactByPhone("${1:905551234567}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Telefon numarasına göre kişi bulur",
                                documentation: "Zoho CRM'de telefon numarasına göre kişi arar. Parametre: phone (string)",
                            },
                            {
                                label: "createContact",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'createContact("${1:Ahmet Yılmaz}", "${2:905551234567}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yeni kişi oluşturur",
                                documentation: "Zoho CRM'de yeni kişi kaydı oluşturur. Parametreler: fullname (string), phone (string)",
                            },
                            {
                                label: "createLead",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'createLead("${1:Ahmet Yılmaz}", "${2:905551234567}", {\n\t${3:Company}: "${4:Acme Corp}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yeni lead oluşturur",
                                documentation: "Zoho CRM'de yeni lead kaydı oluşturur. Parametreler: fullname (string), phone (string), extraData (object, opsiyonel)",
                            },
                            {
                                label: "getLeadByPhone",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getLeadByPhone("${1:905551234567}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Telefon numarasına göre lead bulur",
                                documentation: "Zoho CRM'de telefon numarasına göre lead arar. Parametre: phone (string)",
                            },
                            {
                                label: "createRecord",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'createRecord("${1:Deals}", {\n\t${2:Deal_Name}: "${3:Yeni Anlaşma}",\n\t${4:Amount}: ${5:50000}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Modülde yeni kayıt oluşturur",
                                documentation: "Zoho CRM'de belirtilen modülde yeni kayıt oluşturur. Parametreler: module (string), data (object)",
                            },
                            {
                                label: "updateRecord",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'updateRecord("${1:Leads}", "${2:recordId}", {\n\t${3:Lead_Status}: "${4:Qualified}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Modülde kayıt günceller",
                                documentation: "Zoho CRM'de belirtilen modülde kayıt günceller. Parametreler: module (string), recordId (string), data (object)",
                            },
                            {
                                label: "getRecordById",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getRecordById("${1:Contacts}", "${2:recordId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Modülde ID'ye göre kayıt getirir",
                                documentation: "Zoho CRM'de belirtilen modülde ID'ye göre kayıt getirir. Parametreler: module (string), id (string)",
                            },
                            {
                                label: "getModules",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "getModules()",
                                detail: "Tüm modülleri listeler",
                                documentation: "Zoho CRM'deki tüm modülleri listeler. Parametre yok.",
                            },
                            {
                                label: "getModuleFields",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getModuleFields("${1:Contacts}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Modülün alanlarını getirir",
                                documentation: "Zoho CRM'de belirtilen modülün alanlarını getirir. Parametre: module (string)",
                            },
                            {
                                label: "getOrganizationDetails",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "getOrganizationDetails()",
                                detail: "Organizasyon detaylarını getirir",
                                documentation: "Zoho CRM'deki organizasyon bilgilerini getirir. Parametre yok.",
                            },
                            {
                                label: "getContactById",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getContactById("${1:contactId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kişi ID'sine göre kişi bilgilerini getirir",
                                documentation: "Zoho CRM'de kişi ID'sine göre kişi detaylarını getirir. Parametre: contactId (string)",
                            },
                            {
                                label: "getLeadById",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getLeadById("${1:leadId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Lead ID'sine göre lead bilgilerini getirir",
                                documentation: "Zoho CRM'de lead ID'sine göre lead detaylarını getirir. Parametre: leadId (string)",
                            },
                            {
                                label: "getContactByMobile",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getContactByMobile("${1:905551234567}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Mobil telefon numarasına göre kişi bulur",
                                documentation: "Zoho CRM'de mobil telefon numarasına göre kişi arar. Parametre: phone (string)",
                            },
                            {
                                label: "listRecordsByPhone",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'listRecordsByPhone("${1:Contacts}", "${2:905551234567}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Modülde telefon numarasına göre kayıtları listeler",
                                documentation: "Zoho CRM'de belirtilen modülde telefon numarasına göre kayıtları listeler. Parametreler: module (string), phone (string)",
                            },
                            {
                                label: "getRecordsByPhone",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getRecordsByPhone("${1:Contacts}", "${2:905551234567}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Modülde telefon numarasına göre kayıtları getirir",
                                documentation: "Zoho CRM'de belirtilen modülde telefon numarasına göre kayıtları getirir. Parametreler: module (string), phone (string)",
                            },
                            {
                                label: "getRecordsByMobile",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getRecordsByMobile("${1:Contacts}", "${2:905551234567}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Modülde mobil telefona göre kayıtları getirir",
                                documentation: "Zoho CRM'de belirtilen modülde mobil telefon numarasına göre kayıtları getirir. Parametreler: module (string), phone (string)",
                            },
                            {
                                label: "getRecordsByContactId",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getRecordsByContactId("${1:Leads}", "${2:contactId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Modülde kişi ID'sine göre kayıtları getirir",
                                documentation: "Zoho CRM'de belirtilen modülde kişi ID'sine göre ilişkili kayıtları getirir. Parametreler: module (string), contactId (string)",
                            },
                            {
                                label: "isNewLeadByPhone",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'isNewLeadByPhone("${1:905551234567}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Telefon numarasının yeni lead olup olmadığını kontrol eder",
                                documentation: "Zoho CRM'de telefon numarasının daha önce kayıtlı olup olmadığını kontrol eder. Parametre: phone (string)",
                            },
                            {
                                label: "upsertRecord",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'upsertRecord("${1:Contacts}", {\n\t${2:Email}: "${3:test@example.com}",\n\t${4:First_Name}: "${5:Test}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Modülde kayıt upsert eder",
                                documentation: "Zoho CRM'de belirtilen modülde kayıt upsert eder (var ise günceller, yok ise oluşturur). Parametreler: module (string), data (object)",
                            },
                            {
                                label: "deleteRecords",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'deleteRecords("${1:Leads}", ["${2:recordId1}", "${3:recordId2}"])',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Modülde kayıtları siler",
                                documentation: "Zoho CRM'de belirtilen modülde birden fazla kaydı siler. Parametreler: module (string), recordIds (array)",
                            },
                            {
                                label: "changeOwnerByRecordId",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'changeOwnerByRecordId("${1:Leads}", "${2:recordId}", "${3:newOwnerId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kayıt sahipliğini değiştirir",
                                documentation: "Zoho CRM'de belirtilen kayıtın sahipliğini değiştirir. Parametreler: module (string), recordId (string), ownerId (string)",
                            },
                            {
                                label: "getModuleRelatedLists",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getModuleRelatedLists("${1:Contacts}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Modülün ilişkili listelerini getirir",
                                documentation: "Zoho CRM'de belirtilen modülün ilişkili listelerini getirir. Parametre: module (string)",
                            },
                            {
                                label: "getRelatedRecordData",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getRelatedRecordData("${1:Contacts}", "${2:contactId}", "${3:Leads}", ${4:null})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "İlişkili kayıt verilerini getirir",
                                documentation: "Zoho CRM'de bir kayıtla ilişkili diğer modüldeki kayıtları getirir. Parametreler: module (string), recordId (string), relatedModule (string), fields (array, opsiyonel)",
                            },
                            {
                                label: "uploadAttachmentToRecord",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'uploadAttachmentToRecord("${1:Contacts}", "${2:recordId}", "${3:fileUrl}", "${4:filename}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kayda dosya ekler",
                                documentation: "Zoho CRM'de belirtilen kayda dosya ekler. Parametreler: moduleApiName (string), recordId (string), fileUrl (string), filename (string)",
                            },
                            {
                                label: "uploadFileToZFS",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'uploadFileToZFS("${1:fileUrl}", "${2:filename}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Zoho File System'e dosya yükler",
                                documentation: "Zoho File System'e dosya yükler ve file ID döner. Parametreler: fileUrl (string), filename (string)",
                            },
                            {
                                label: "uploadImageToField",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'uploadImageToField("${1:Contacts}", "${2:recordId}", "${3:fieldId}", "${4:fileUrl}", "${5:filename}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Alana resim yükler",
                                documentation: "Zoho CRM'de belirtilen kayıt alanına resim yükler. Parametreler: moduleApiName (string), recordId (string), fieldId (string), fileUrl (string), filename (string)",
                            },
                        ],
                    };
                }

                // asset. alt metodları
                const assetMatch = lastWord.match(/^supsis\.asset\.?$/);
                if (assetMatch) {
                    return {
                        suggestions: [
                            {
                                label: "create",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'create("${1:https://example.com/sample.pdf}", "${2:file}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "URL'den bir asset (dosya) oluşturur",
                                documentation: "URL'den bir asset (dosya) oluşturur ve S3'e yükler.\nParametreler:\n- url: Dosya URL'si (zorunlu)\n- fieldType: Dosya tipi (opsiyonel, varsayılan: 'file'). Değerler: 'image', 'audio', 'video', 'file'\nDönen değer: Asset objesi",
                            },
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "get(${1:id})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Asset bilgilerini getirir",
                                documentation: "Belirtilen ID'ye sahip asset'in detaylarını getirir.\nParametreler:\n- id: Asset ID'si (zorunlu)\nDönen değer: Asset objesi",
                            },
                        ],
                    };
                }

                // util. alt metodları
                const utilMatch = lastWord.match(/^supsis\.util\.?$/);
                if (utilMatch) {
                    return {
                        suggestions: [
                            {
                                label: "html2md",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'html2md("${1:<h1>Hello World</h1><p>Test content</p>}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "HTML'i markdown formatına çevirir",
                                documentation: "HTML içeriğini markdown formatına çevirir.\nParametreler:\n- html: Çevrilecek HTML string (zorunlu)\nDönen değer: Markdown formatında string\nÖrnek: supsis.util.html2md('<h1>Başlık</h1><p>İçerik</p>')",
                            },
                            {
                                label: "url2md",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'url2md("${1:https://example.com}", ${2:10000}, ${3:null})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "URL'den HTML alıp markdown'a çevirir",
                                documentation: "Belirtilen URL'den HTML içeriğini alır ve markdown formatına çevirir.\nParametreler:\n- url: İçeriği alınacak URL (zorunlu)\n- timeout: İstek zaman aşımı ms (opsiyonel, varsayılan: 10000)\n- proxy: Proxy ayarları (opsiyonel, varsayılan: null) - Örnek: { host: 'proxy.example.com', port: 8080, auth: { username: 'user', password: 'pass' } }\nDönen değer: Promise<string> - Markdown formatında içerik\nÖrnek: await supsis.util.url2md('https://example.com', 15000, { host: 'proxy.com', port: 8080 })",
                            },
                            {
                                label: "encodeUri",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'encodeUri("${1:text to encode}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "URI bileşenini encode eder",
                                documentation: "String'i URL-safe formata çevirir (encodeURIComponent wrapper).\nParametreler:\n- str: Encode edilecek string (zorunlu)\nDönen değer: string - Encode edilmiş string\nÖrnek: supsis.util.encodeUri('hello world') // 'hello%20world'",
                            },
                            {
                                label: "decodeUri",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'decodeUri("${1:encoded%20text}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "URI bileşenini decode eder",
                                documentation: "URL-safe formatından normal string'e çevirir (decodeURIComponent wrapper).\nParametreler:\n- str: Decode edilecek string (zorunlu)\nDönen değer: string - Decode edilmiş string\nÖrnek: supsis.util.decodeUri('hello%20world') // 'hello world'",
                            },
                        ],
                    };
                }

                // ikas. alt metodları
                const ikasMatch = lastWord.match(/^supsis\.ikas\.?$/);
                if (ikasMatch) {
                    return {
                        suggestions: [
                            {
                                label: "product",
                                kind: monaco.languages.CompletionItemKind.Module,
                                insertText: "product",
                                detail: "İkas Ürün alt modülü",
                                documentation: "İkas e-ticaret platformundaki ürün işlemleri için kullanılır"
                            },
                            {
                                label: "customer",
                                kind: monaco.languages.CompletionItemKind.Module,
                                insertText: "customer",
                                detail: "İkas Müşteri alt modülü",
                                documentation: "İkas e-ticaret platformundaki müşteri işlemleri için kullanılır",
                            },
                            {
                                label: "order",
                                kind: monaco.languages.CompletionItemKind.Module,
                                insertText: "order",
                                detail: "İkas Sipariş alt modülü",
                                documentation: "İkas e-ticaret platformundaki sipariş işlemleri için kullanılır",
                            }
                        ],
                    };
                }
                // ikas.product. alt metodları
                const ikasProductMatch = lastWord.match(/^supsis\.ikas\.product\.?$/);
                if (ikasProductMatch) {
                    return {
                        suggestions: [
                            {
                                label: "list",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "list(\"${1:ikasChannelId}\", {\n  page: ${2:1},\n  limit: ${3:20},\n  search: \"${4:}\"\n})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "İkas ürün listesini getirir (v2)",
                                documentation: "İkas e-ticaret platformundan ürün listesini getirir (API v2).\nParametreler:\n- channelId: İkas kanal ID'si (zorunlu)\n- options: Listeleme seçenekleri (opsiyonel)\n  - page: Sayfa numarası (varsayılan: 1)\n  - limit: Sayfa başına kayıt sayısı (varsayılan: 20, max: 100)\n  - search: Arama terimi (opsiyonel)\nDönen değer: {data: Array, total: number, page: number, limit: number, hasNext: boolean}\nYeni yapı: Sadeleştirilmiş JSON, renk/beden gruplandırması, resim URL'leri hazır",
                            },
                            {
                                label: "search",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "search(\"${1:ikasChannelId}\", {\n  search: \"${2:arama kelimesi}\",\n  page: ${3:1},\n  limit: ${4:20}\n})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "İkas ürün arama yapar (isme göre)",
                                documentation: "İkas e-ticaret platformunda ürün araması yapar (isme göre arama).\nParametreler:\n- channelId: İkas kanal ID'si (zorunlu)\n- searchOptions: Arama seçenekleri\n  - search: Arama sorgusu (isme göre)\n  - sku: SKU/Stok kodu (stok koduna göre) - search ile aynı anda kullanılmaz\n  - page: Sayfa numarası (varsayılan: 1)\n  - limit: Sayfa başına kayıt sayısı (varsayılan: 20, max: 100)\nDönen değer: {data: Array, total: number, page: number, limit: number, hasNext: boolean}\nNOT: search ve sku parametreleri aynı anda kullanılmaz. sku önceliklidir.",
                            },
                            {
                                label: "search (SKU)",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "search(\"${1:ikasChannelId}\", {\n  sku: \"${2:MEGKYL01}\",\n  page: ${3:1},\n  limit: ${4:20}\n})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "İkas ürün arama yapar (SKU'ya göre)",
                                documentation: "İkas e-ticaret platformunda ürün araması yapar (SKU/stok koduna göre arama).\nParametreler:\n- channelId: İkas kanal ID'si (zorunlu)\n- searchOptions: Arama seçenekleri\n  - sku: SKU/Stok kodu (zorunlu)\n  - page: Sayfa numarası (varsayılan: 1)\n  - limit: Sayfa başına kayıt sayısı (varsayılan: 20, max: 100)\nDönen değer: {data: Array, total: number, page: number, limit: number, hasNext: boolean}\nNOT: sku parametresi search parametresinden önceliklidir.",
                            },
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'get("${1:ikasChannelId}", "${2:productId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "İkas ürünü ID'sine göre getirir (v2)",
                                documentation: "İkas e-ticaret platformundan belirli bir ürünü ID'sine göre getirir (API v2).\nParametreler:\n- channelId: İkas kanal ID'si (zorunlu)\n- productId: Ürün ID'si (zorunlu)\nDönen değer: Sadeleştirilmiş product objesi (renk/beden seçenekleri, stok bilgisi, resim URL'leri dahil)",
                            },
                        ],
                    };
                }

                const ikasCustomerMatch = lastWord.match(/^supsis\.ikas\.customer\.?$/);
                if (ikasCustomerMatch) {
                    return {
                        suggestions: [
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "get(\"${1:ikasChannelId}\", \"${2:email@example.com veya 905xxxxxxxxx}\")",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "İkas müşteriyi email/telefon ile getirir",
                                documentation: "İkas e-ticaret platformundan müşteriyi email veya telefon numarasına göre getirir.\nParametreler:\n- channelId: İkas kanal ID'si (zorunlu)\n- identifier: Email adresi veya telefon numarası (zorunlu)\nDönen değer: Customer objesi veya null\nÖrnek: get('channelId', 'test@example.com') veya get('channelId', '905551234567')",
                            },
                        ],
                    };
                }

                const ikasOrderMatch = lastWord.match(/^supsis\.ikas\.order\.?$/);
                if (ikasOrderMatch) {
                    return {
                        suggestions: [
                            {
                                label: "getOrderStatus",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "getOrderStatus(\"${1:ikasChannelId}\", \"${2:orderNumber}\")",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "İkas sipariş durumunu getirir (takip bilgileri dahil)",
                                documentation: "İkas e-ticaret platformundan sipariş durumunu ve takip bilgilerini getirir.\nParametreler:\n- channelId: İkas kanal ID'si (zorunlu)\n- orderNumber: Sipariş numarası (zorunlu)\nDönen değer: Order objesi (takip bilgileri dahil) veya null",
                            },
                            {
                                label: "getCustomerOrders",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "getCustomerOrders(\"${1:ikasChannelId}\", \"${2:email@example.com veya 905xxxxxxxxx}\")",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "İkas müşterinin siparişlerini email/telefon ile getirir",
                                documentation: "İkas e-ticaret platformundan müşterinin siparişlerini email veya telefon numarası ile getirir.\nParametreler:\n- channelId: İkas kanal ID'si (zorunlu)\n- identifier: Email adresi veya telefon numarası (zorunlu)\nDönen değer: Order array\nÖrnek: getCustomerOrders('channelId', 'test@example.com') veya getCustomerOrders('channelId', '905551234567')",
                            },
                            {
                                label: "list",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'list("${1:ikasChannelId}", {\n  page: ${2:1},\n  limit: ${3:20}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "İkas sipariş listesini getirir (detaylı bilgilerle)",
                                documentation:
                                    "İkas e-ticaret platformundan sipariş listesini detaylı bilgilerle getirir.\nParametreler:\n- channelId: İkas kanal ID'si (zorunlu)\n- options: { page?, limit? } (opsiyonel)\nlimit maksimum 100 olabilir.\nDönen değer: { data, total, page, limit, hasNext }\nSipariş detayları: orderNumber, orderedAt, totalFinalPrice, customer, shippingAddress, billingAddress, lineItems (ürün bilgileri, görseller, fiyatlar, discountPrice, discountAmount), packages (takip bilgileri dahil)",
                            },
                        ],
                    };
                }

                // balance. alt metodları
                const balanceMatch = lastWord.match(/^supsis\.balance\.?$/);
                if (balanceMatch) {
                    return {
                        suggestions: [
                            {
                                label: "addActivity",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'addActivity({\n\tamount: ${1:10.50},\n\tdescription: "${2:Dış hizmet kullanımı}",\n\ttype: "${3:custom}",\n\tmetadata: {\n\t\tservice: "${4:external-service}",\n\t\tprovider: "${5:service-provider}"\n\t}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Cüzdandan bakiye düşer ve aktivite oluşturur",
                                documentation: "Otomasyonda kullanılan dış hizmetler için cüzdan bakiyesinden düşüm yapar.\nParametreler:\n- amount: Düşülecek miktar (number, zorunlu, pozitif olmalı)\n- description: Açıklama (string, opsiyonel)\n- type: İşlem tipi (string, opsiyonel, varsayılan: 'custom'). Değerler: 'custom', 'cloud-convert', 'speech-to-text', 'ai-usage' vb.\n- metadata: Ek bilgiler (object, opsiyonel)\nDönen değer: Güncellenmiş cüzdan objesi",
                            },
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'get()',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Cüzdan bakiye bilgisini getirir",
                                documentation: "Belirtilen cüzdan tipinin bakiye bilgisini getirir.\nParametreler:\n- walletType: Cüzdan tipi (string, opsiyonel, varsayılan: 'whatsapp')\nDönen değer: { amount, type, exists, supported, maxLowBalance }",
                            },
                        ],
                    };
                }

                // voiceagent. alt metodları
                const voiceagentMatch = lastWord.match(/^supsis\.voiceagent\.?$/);
                if (voiceagentMatch) {
                    return {
                        suggestions: [
                            {
                                label: "makeCall",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'makeCall({\n\tagentId: "${1:agent-id}",\n\tfromNumber: "${2:905551234567}",\n\ttoNumber: "${3:905559876543}",\n\tvariables: {\n\t\t${4:customerName}: "${5:Ahmet Yılmaz}",\n\t\t${6:orderNumber}: "${7:ORD-12345}"\n\t},\n\tmetadata: {\n\t\t${8:campaignId}: "${9:campaign-xyz}"\n\t}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yapay zeka destekli telefon araması başlatır",
                                documentation: "Voice agent kullanarak yapay zeka destekli telefon araması başlatır.\nParametreler:\n- agentId: Voice agent ID'si (string, zorunlu)\n- fromNumber: Arayan numara (string, zorunlu, ülke kodlu)\n- toNumber: Aranan numara (string, zorunlu, ülke kodlu)\n- variables: Yapay zeka için dinamik değişkenler (object, opsiyonel)\n- metadata: Ek bilgiler (object, opsiyonel)\nDönen değer: { call_id, call_status, agent_id, from_number, to_number }",
                            },
                            {
                                label: "getCall",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'getCall("${1:call-id}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yapay zeka araması kaydını getirir",
                                documentation: "Arama ID'sine göre yapay zeka araması kaydını getirir.\nParametreler:\n- callId: Arama ID'si (string, zorunlu)\nDönen değer: Arama kayıt objesi (call_id, call_status, transcript, duration, recording_url vb.)",
                            },
                        ],
                    };
                }

                // cache. alt metodları
                const cacheMatch = lastWord.match(/^supsis\.cache\.?$/);
                if (cacheMatch) {
                    return {
                        suggestions: [
                            {
                                label: "write",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'write("${1:cache_key}", ${2:value}, {\n\ttype: "${3:public}",\n\tdataType: "${4:mixed}",\n\texpiresIn: { value: ${5:24}, unit: "${6:hours}" }\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Cache yazar veya günceller",
                                documentation: "Cache sistemi cache yazar veya günceller (upsert).\nParametreler:\n- key: Cache anahtarı (string, zorunlu, unique)\n- value: Kaydedilecek değer (any type, zorunlu)\n- options: Cache seçenekleri (object, opsiyonel)\n  - type: 'public' (herkes erişebilir) veya 'private' (sadece oluşturan), varsayılan: 'public'\n  - dataType: UI'da gösterim için veri tipi ('string', 'number', 'boolean', 'date', 'json', 'array', 'objectid_user', 'mixed'), varsayılan: 'mixed'\n  - expiresIn: Geçerlilik süresi { value: number, unit: 'seconds'|'minutes'|'hours'|'days' }, opsiyonel\n  - expiresAt: Belirli bir tarih (Date), opsiyonel\nDönen değer: { success: boolean, key: string, cacheId: string }\n\nÖrnek:\nawait supsis.cache.write('user_session_123', { logged: true, lastAccess: Date.now() }, {\n  type: 'public',\n  dataType: 'json',\n  expiresIn: { value: 24, unit: 'hours' }\n});",
                            },
                            {
                                label: "read",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'read("${1:cache_key}", ${2:defaultValue})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Cache okur",
                                documentation: "Cache sisteminden değer okur.\nParametreler:\n- key: Cache anahtarı (string, zorunlu)\n- defaultValue: Cache bulunamazsa veya expire olduysa döndürülecek değer (any type, opsiyonel, varsayılan: null)\nDönen değer: Cache'deki değer veya defaultValue\n\nÖrnek:\nconst session = await supsis.cache.read('user_session_123', { logged: false });\nif (session.logged) {\n  console.log('Kullanıcı aktif');\n}",
                            },
                            {
                                label: "extend",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'extend("${1:cache_key}", { value: ${2:24}, unit: "${3:hours}" })',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Cache geçerlilik süresini uzatır",
                                documentation: "Cache'in geçerlilik süresini uzatır (şu andan itibaren).\nParametreler:\n- key: Cache anahtarı (string, zorunlu)\n- expiresIn: Yeni geçerlilik süresi { value: number, unit: 'seconds'|'minutes'|'hours'|'days' } (object, zorunlu)\nDönen değer: { success: boolean, key: string, expiresAt: Date }\n\nÖrnek:\nawait supsis.cache.extend('user_session_123', { value: 48, unit: 'hours' });",
                            },
                            {
                                label: "delete",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'delete("${1:cache_key}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Cache siler",
                                documentation: "Cache sisteminden tek bir cache siler.\nParametreler:\n- key: Cache anahtarı (string, zorunlu)\nDönen değer: { success: boolean, key: string }\n\nÖrnek:\nawait supsis.cache.delete('user_session_123');",
                            },
                            {
                                label: "list",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'list("${1:*pattern*}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Cache listeler (pattern destekli)",
                                documentation: "Cache sisteminden pattern ile eşleşen cache'leri listeler.\nParametreler:\n- pattern: Wildcard pattern (string, opsiyonel)\n  - 'chat*': 'chat' ile başlayanlar\n  - '*chat': 'chat' ile bitenler\n  - '*chat*': içinde 'chat' geçenler\n  - null: tüm cache'ler\nDönen değer: Array<{key, value, type, dataType, expiresAt, createdBy...}>\n\nÖrnek:\nconst sessions = await supsis.cache.list('user_session_*');\nsessions.forEach(cache => {\n  console.log(cache.key, cache.value);\n});",
                            },
                        ],
                    };
                }

                // youtube. alt metodları
                const youtubeMatch = lastWord.match(/^supsis\.youtube\.?$/);
                if (youtubeMatch) {
                    return {
                        suggestions: [
                            {
                                label: "video",
                                kind: monaco.languages.CompletionItemKind.Module,
                                insertText: "video",
                                detail: "YouTube Video Alt Modülü",
                                documentation: "YouTube video işlemleri için API modülü",
                            },
                            {
                                label: "comment",
                                kind: monaco.languages.CompletionItemKind.Module,
                                insertText: "comment",
                                detail: "YouTube Comment Alt Modülü",
                                documentation: "YouTube yorum işlemleri için API modülü",
                            },
                        ],
                    };
                }

                // youtube.video. alt metodları
                const youtubeVideoMatch = lastWord.match(/^supsis\.youtube\.video\.?$/);
                if (youtubeVideoMatch) {
                    return {
                        suggestions: [
                            {
                                label: "list",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'list("${1:channelId}", { page: ${2:1}, limit: ${3:25} })',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "YouTube videolarını listeler",
                                documentation: "Belirtilen kanala ait videoları sayfalı olarak listeler.\nParametreler:\n- channelId: YouTube kanal ID (string, zorunlu)\n- options: Listeleme seçenekleri (object, opsiyonel)\n  - page: Sayfa numarası (number, varsayılan: 1)\n  - limit: Sayfa başına video sayısı (number, varsayılan: 25)\nDönüş: { items: Video[], total: number }",
                            },
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'get("${1:videoId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Video detaylarını getirir",
                                documentation: "Video ID'sine göre video detaylarını getirir.\nParametreler:\n- videoId: YouTube video ID (string, zorunlu)\nDönüş: Video objesi (title, description, viewCount, likeCount, commentCount, vb.)",
                            },
                        ],
                    };
                }

                // youtube.comment. alt metodları
                const youtubeCommentMatch = lastWord.match(/^supsis\.youtube\.comment\.?$/);
                if (youtubeCommentMatch) {
                    return {
                        suggestions: [
                            {
                                label: "list",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'list({\n\tchannelId: "${1:channelId}",\n\tvideoId: "${2:videoId}",\n\tstatus: "${3:new}",\n\tpage: ${4:1},\n\tlimit: ${5:20}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "YouTube yorumlarını listeler",
                                documentation: "Filtrelere göre yorumları sayfalı olarak listeler.\nParametreler:\n- options: Listeleme seçenekleri (object)\n  - channelId: Kanal ID (string, opsiyonel)\n  - videoId: Video ID (string, opsiyonel)\n  - status: Yorum durumu - 'new'|'replied'|'resolved' (string, opsiyonel)\n  - parentId: Üst yorum ID (string, opsiyonel)\n  - search: Arama metni (string, opsiyonel)\n  - page: Sayfa numarası (number, varsayılan: 1)\n  - limit: Sayfa başına yorum sayısı (number, varsayılan: 20)\nDönüş: { items: Comment[], total: number }",
                            },
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'get("${1:commentId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yorum detaylarını getirir",
                                documentation: "Comment ID'sine göre yorum detaylarını getirir.\nParametreler:\n- commentId: YouTube yorum ID (string, zorunlu)\nDönüş: Comment objesi (text, authorDisplayName, likeCount, status, moderationStatus, vb.)",
                            },
                            {
                                label: "reply",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'reply("${1:channelId}", "${2:commentId}", "${3:Yanıt metni}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yoruma yanıt verir",
                                documentation: "Belirtilen yoruma yanıt gönderir.\nParametreler:\n- channelId: YouTube kanal ID (string, zorunlu)\n- commentId: Yanıtlanacak yorum ID (string, zorunlu)\n- text: Yanıt metni (string, zorunlu)\nDönüş: Oluşturulan yanıt objesi",
                            },
                            {
                                label: "updateStatus",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'updateStatus("${1:commentId}", "${2:resolved}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yorum durumunu günceller",
                                documentation: "Yorumun Supsis içindeki durumunu günceller.\nParametreler:\n- commentId: Yorum ID (string, zorunlu)\n- status: Yeni durum - 'new'|'replied'|'resolved' (string, zorunlu)\nDönüş: Güncellenen yorum objesi",
                            },
                            {
                                label: "setModerationStatus",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'setModerationStatus("${1:channelId}", "${2:commentId}", "${3:published}", ${4:false})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "YouTube moderasyon durumunu ayarlar",
                                documentation: "Yorumun YouTube'daki moderasyon durumunu değiştirir.\nParametreler:\n- channelId: YouTube kanal ID (string, zorunlu)\n- commentId: Yorum ID (string, zorunlu)\n- moderationStatus: Moderasyon durumu - 'published'|'heldForReview'|'rejected' (string, zorunlu)\n- banAuthor: Yorum sahibini banla (boolean, varsayılan: false)\nDönüş: { success: boolean, moderationStatus: string, banAuthor: boolean }",
                            },
                        ],
                    };
                }

                // googlebusiness. alt metodları
                const googleBusinessMatch = lastWord.match(/^supsis\.googlebusiness\.?$/);
                if (googleBusinessMatch) {
                    return {
                        suggestions: [
                            {
                                label: "location",
                                kind: monaco.languages.CompletionItemKind.Module,
                                insertText: "location",
                                detail: "Google Business Location Alt Modülü",
                                documentation: "Google Business konum işlemleri için API modülü",
                            },
                            {
                                label: "review",
                                kind: monaco.languages.CompletionItemKind.Module,
                                insertText: "review",
                                detail: "Google Business Review Alt Modülü",
                                documentation: "Google Business yorum işlemleri için API modülü",
                            },
                        ],
                    };
                }

                // googlebusiness.location. alt metodları
                const googleBusinessLocationMatch = lastWord.match(/^supsis\.googlebusiness\.location\.?$/);
                if (googleBusinessLocationMatch) {
                    return {
                        suggestions: [
                            {
                                label: "list",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'list("${1:channelId}", { page: ${2:1}, limit: ${3:25} })',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Google Business konumlarını listeler",
                                documentation: "Belirtilen kanala ait konumları sayfalı olarak listeler.\nParametreler:\n- channelId: Google Business kanal ID (string, zorunlu)\n- options: Listeleme seçenekleri (object, opsiyonel)\n  - page: Sayfa numarası (number, varsayılan: 1)\n  - limit: Sayfa başına konum sayısı (number, varsayılan: 25)\nDönüş: { items: Location[], total: number }",
                            },
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'get("${1:locationId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Konum detaylarını getirir",
                                documentation: "Location ID'sine göre konum detaylarını getirir.\nParametreler:\n- locationId: Google Business konum ID (string, zorunlu)\nDönüş: Location objesi (title, address, phoneNumber, websiteUri, vb.)",
                            },
                        ],
                    };
                }

                // googlebusiness.review. alt metodları
                const googleBusinessReviewMatch = lastWord.match(/^supsis\.googlebusiness\.review\.?$/);
                if (googleBusinessReviewMatch) {
                    return {
                        suggestions: [
                            {
                                label: "list",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'list({\n\tchannelId: "${1:channelId}",\n\tlocationId: "${2:locationId}",\n\tstatus: "${3:new}",\n\tpage: ${4:1},\n\tlimit: ${5:20}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Google Business yorumlarını listeler",
                                documentation: "Filtrelere göre yorumları sayfalı olarak listeler.\nParametreler:\n- options: Listeleme seçenekleri (object)\n  - channelId: Kanal ID (string, opsiyonel)\n  - locationId: Konum ID (string, opsiyonel)\n  - status: Yorum durumu - 'new'|'replied'|'resolved' (string, opsiyonel)\n  - page: Sayfa numarası (number, varsayılan: 1)\n  - limit: Sayfa başına yorum sayısı (number, varsayılan: 20)\nDönüş: { items: Review[], total: number }",
                            },
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'get("${1:reviewId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yorum detaylarını getirir",
                                documentation: "Review ID'sine göre yorum detaylarını getirir.\nParametreler:\n- reviewId: Google Business yorum ID (string, zorunlu)\nDönüş: Review objesi (comment, starRating, reviewer, status, vb.)",
                            },
                            {
                                label: "reply",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'reply("${1:channelId}", "${2:reviewId}", "${3:Yanıt metni}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yoruma yanıt verir",
                                documentation: "Belirtilen yoruma yanıt gönderir.\nParametreler:\n- channelId: Google Business kanal ID (string, zorunlu)\n- reviewId: Yanıtlanacak yorum ID (string, zorunlu)\n- text: Yanıt metni (string, zorunlu)\nDönüş: Oluşturulan yanıt objesi",
                            },
                            {
                                label: "updateStatus",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'updateStatus("${1:reviewId}", "${2:resolved}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yorum durumunu günceller",
                                documentation: "Yorumun Supsis içindeki durumunu günceller.\nParametreler:\n- reviewId: Yorum ID (string, zorunlu)\n- status: Yeni durum - 'new'|'replied'|'resolved' (string, zorunlu)\nDönüş: Güncellenen yorum objesi",
                            },
                        ],
                    };
                }

                // googleplay. alt metodları
                const googlePlayMatch = lastWord.match(/^supsis\.googleplay\.?$/);
                if (googlePlayMatch) {
                    return {
                        suggestions: [
                            {
                                label: "app",
                                kind: monaco.languages.CompletionItemKind.Module,
                                insertText: "app",
                                detail: "Google Play App Alt Modülü",
                                documentation: "Google Play uygulama işlemleri için API modülü",
                            },
                            {
                                label: "review",
                                kind: monaco.languages.CompletionItemKind.Module,
                                insertText: "review",
                                detail: "Google Play Review Alt Modülü",
                                documentation: "Google Play yorum işlemleri için API modülü",
                            },
                        ],
                    };
                }

                // googleplay.app. alt metodları
                const googlePlayAppMatch = lastWord.match(/^supsis\.googleplay\.app\.?$/);
                if (googlePlayAppMatch) {
                    return {
                        suggestions: [
                            {
                                label: "list",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'list("${1:channelId}", { page: ${2:1}, limit: ${3:25} })',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Google Play uygulamalarını listeler",
                                documentation: "Belirtilen kanala ait uygulamaları sayfalı olarak listeler.\nParametreler:\n- channelId: Google Play kanal ID (string, zorunlu)\n- options: Listeleme seçenekleri (object, opsiyonel)\n  - page: Sayfa numarası (number, varsayılan: 1)\n  - limit: Sayfa başına uygulama sayısı (number, varsayılan: 25)\nDönüş: { items: App[], total: number }",
                            },
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'get("${1:appId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Uygulama detaylarını getirir",
                                documentation: "App ID'sine göre uygulama detaylarını getirir.\nParametreler:\n- appId: Google Play uygulama ID (string, zorunlu)\nDönüş: App objesi (packageName, appName, iconUrl, totalReviewCount, averageRating, vb.)",
                            },
                        ],
                    };
                }

                // googleplay.review. alt metodları
                const googlePlayReviewMatch = lastWord.match(/^supsis\.googleplay\.review\.?$/);
                if (googlePlayReviewMatch) {
                    return {
                        suggestions: [
                            {
                                label: "list",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'list({\n\tchannelId: "${1:channelId}",\n\tpackageName: "${2:packageName}",\n\tstatus: "${3:new}",\n\tpage: ${4:1},\n\tlimit: ${5:20}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Google Play yorumlarını listeler",
                                documentation: "Filtrelere göre yorumları sayfalı olarak listeler.\nParametreler:\n- options: Listeleme seçenekleri (object)\n  - channelId: Kanal ID (string, opsiyonel)\n  - packageName: Paket adı (string, opsiyonel)\n  - status: Yorum durumu - 'new'|'replied'|'resolved' (string, opsiyonel)\n  - page: Sayfa numarası (number, varsayılan: 1)\n  - limit: Sayfa başına yorum sayısı (number, varsayılan: 20)\nDönüş: { items: Review[], total: number }",
                            },
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'get("${1:reviewId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yorum detaylarını getirir",
                                documentation: "Review ID'sine göre yorum detaylarını getirir.\nParametreler:\n- reviewId: Google Play yorum ID (string, zorunlu)\nDönüş: Review objesi (comment, starRating, authorName, deviceMetadata, status, vb.)",
                            },
                            {
                                label: "reply",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'reply("${1:channelId}", "${2:reviewId}", "${3:Yanıt metni (max 350 karakter)}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yoruma yanıt verir (max 350 karakter)",
                                documentation: "Belirtilen yoruma yanıt gönderir.\nParametreler:\n- channelId: Google Play kanal ID (string, zorunlu)\n- reviewId: Yanıtlanacak yorum ID (string, zorunlu)\n- text: Yanıt metni (string, zorunlu, maksimum 350 karakter)\nDönüş: Oluşturulan yanıt objesi",
                            },
                            {
                                label: "updateStatus",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'updateStatus("${1:reviewId}", "${2:resolved}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yorum durumunu günceller",
                                documentation: "Yorumun Supsis içindeki durumunu günceller.\nParametreler:\n- reviewId: Yorum ID (string, zorunlu)\n- status: Yeni durum - 'new'|'replied'|'resolved' (string, zorunlu)\nDönüş: Güncellenen yorum objesi",
                            },
                        ],
                    };
                }

                // appstore. alt metodları
                const appStoreMatch = lastWord.match(/^supsis\.appstore\.?$/);
                if (appStoreMatch) {
                    return {
                        suggestions: [
                            {
                                label: "app",
                                kind: monaco.languages.CompletionItemKind.Module,
                                insertText: "app",
                                detail: "App Store App Alt Modülü",
                                documentation: "App Store uygulama işlemleri için API modülü",
                            },
                            {
                                label: "review",
                                kind: monaco.languages.CompletionItemKind.Module,
                                insertText: "review",
                                detail: "App Store Review Alt Modülü",
                                documentation: "App Store yorum işlemleri için API modülü",
                            },
                        ],
                    };
                }

                // appstore.app. alt metodları
                const appStoreAppMatch = lastWord.match(/^supsis\.appstore\.app\.?$/);
                if (appStoreAppMatch) {
                    return {
                        suggestions: [
                            {
                                label: "list",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'list("${1:channelId}", { page: ${2:1}, limit: ${3:25} })',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "App Store uygulamalarını listeler",
                                documentation: "Belirtilen kanala ait uygulamaları sayfalı olarak listeler.\nParametreler:\n- channelId: App Store kanal ID (string, zorunlu)\n- options: Listeleme seçenekleri (object, opsiyonel)\n  - page: Sayfa numarası (number, varsayılan: 1)\n  - limit: Sayfa başına uygulama sayısı (number, varsayılan: 25)\nDönüş: { items: App[], total: number }",
                            },
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'get("${1:appId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Uygulama detaylarını getirir",
                                documentation: "App ID'sine göre uygulama detaylarını getirir.\nParametreler:\n- appId: App Store uygulama ID (string, zorunlu)\nDönüş: App objesi (bundleId, name, iconUrl, totalReviewCount, averageRating, vb.)",
                            },
                        ],
                    };
                }

                // appstore.review. alt metodları
                const appStoreReviewMatch = lastWord.match(/^supsis\.appstore\.review\.?$/);
                if (appStoreReviewMatch) {
                    return {
                        suggestions: [
                            {
                                label: "list",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'list({\n\tchannelId: "${1:channelId}",\n\tappId: "${2:appId}",\n\tstatus: "${3:new}",\n\tpage: ${4:1},\n\tlimit: ${5:20}\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "App Store yorumlarını listeler",
                                documentation: "Filtrelere göre yorumları sayfalı olarak listeler.\nParametreler:\n- options: Listeleme seçenekleri (object)\n  - channelId: Kanal ID (string, opsiyonel)\n  - appId: Uygulama ID (string, opsiyonel)\n  - status: Yorum durumu - 'new'|'replied'|'resolved' (string, opsiyonel)\n  - page: Sayfa numarası (number, varsayılan: 1)\n  - limit: Sayfa başına yorum sayısı (number, varsayılan: 20)\nDönüş: { items: Review[], total: number }",
                            },
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'get("${1:reviewId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yorum detaylarını getirir",
                                documentation: "Review ID'sine göre yorum detaylarını getirir.\nParametreler:\n- reviewId: App Store yorum ID (string, zorunlu)\nDönüş: Review objesi (body, rating, reviewerNickname, territory, status, vb.)",
                            },
                            {
                                label: "reply",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'reply("${1:channelId}", "${2:reviewId}", "${3:Yanıt metni}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yoruma yanıt verir",
                                documentation: "Belirtilen yoruma yanıt gönderir.\nParametreler:\n- channelId: App Store kanal ID (string, zorunlu)\n- reviewId: Yanıtlanacak yorum ID (string, zorunlu)\n- text: Yanıt metni (string, zorunlu)\nDönüş: Oluşturulan yanıt objesi",
                            },
                            {
                                label: "updateResponse",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'updateResponse("${1:channelId}", "${2:reviewId}", "${3:Güncellenmiş yanıt metni}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yorum yanıtını günceller",
                                documentation: "Belirtilen yorumdaki mevcut yanıtı günceller.\nParametreler:\n- channelId: App Store kanal ID (string, zorunlu)\n- reviewId: Yanıt güncellenecek yorum ID (string, zorunlu)\n- text: Yeni yanıt metni (string, zorunlu)\nDönüş: Güncellenen yanıt objesi",
                            },
                            {
                                label: "deleteResponse",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'deleteResponse("${1:channelId}", "${2:reviewId}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yorum yanıtını siler",
                                documentation: "Belirtilen yorumdaki yanıtı kalıcı olarak siler.\nParametreler:\n- channelId: App Store kanal ID (string, zorunlu)\n- reviewId: Yanıtı silinecek yorum ID (string, zorunlu)\nDönüş: Silme sonucu objesi",
                            },
                            {
                                label: "updateStatus",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'updateStatus("${1:reviewId}", "${2:resolved}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yorum durumunu günceller",
                                documentation: "Yorumun Supsis içindeki durumunu günceller.\nParametreler:\n- reviewId: Yorum ID (string, zorunlu)\n- status: Yeni durum - 'new'|'replied'|'resolved' (string, zorunlu)\nDönüş: Güncellenen yorum objesi",
                            },
                        ],
                    };
                }

                // queue. alt metodları
                const queueMatch = lastWord.match(/^supsis\.queue\.?$/);
                if (queueMatch) {
                    return {
                        suggestions: [
                            {
                                label: "add",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'add(async function() {\n\t${1:// Kuyrukta çalışacak işlem}\n\treturn { success: true };\n}, "${2:job_type}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kuyruğa iş ekler",
                                documentation: "İşlem kuyruğuna yeni bir iş ekler ve sırasıyla çalıştırır.\nParametreler:\n- operation: Çalıştırılacak asenkron fonksiyon (function, zorunlu)\n- type: İşlem tipi/anahtarı (string, varsayılan: 'custom') - Örn: 'send_email_to_customers', 'process_orders'\nDönen değer: Promise - İşlem tamamlandığında resolve olur\n\nÖrnek:\nawait supsis.queue.add(async function() {\n  const users = await supsis.users.list();\n  // ... işlemler\n  return { processed: users.length };\n}, 'process_users');",
                            },
                            {
                                label: "clean",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'clean("${1:job_type}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kuyruğu temizler",
                                documentation: "Kuyruktan belirli tipteki işleri temizler.\nParametreler:\n- type: İşlem tipi (string, zorunlu) - Sadece bu tipteki işleri temizler\nDönen değer: { success: boolean, message: string }\n\nÖrnek:\nsupsis.queue.clean('send_email_to_customers')\n\nNot: Type'lar otomatik olarak 'automation_{type}_{siteId}' formatına dönüştürülür.",
                            },
                            {
                                label: "status",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: 'status("${1:job_type}")',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kuyruk durumunu getirir",
                                documentation: "Kuyruk durumu ve istatistiklerini getirir.\nParametreler:\n- type: İşlem tipi (string, opsiyonel) - Belirtilirse sadece o type'ın durumunu döndürür\n\nType belirtilmişse dönen değer:\n{\n  type: string,\n  queueLength: number,\n  hasItems: boolean,\n  stats: { waiting, processing, completed, failed, total, progress },\n  items: Array<{ type, addedAt, waitingTime }>\n}\n\nType belirtilmemişse dönen değer:\n{\n  queueLength: number,\n  isProcessing: boolean,\n  stats: { overall, byType },\n  currentOperations: Array\n}\n\nÖrnekler:\n// Belirli tip durumu\nconst emailStatus = supsis.queue.status('send_email_to_customers');\nconsole.log(`Email işleri: ${emailStatus.stats.completed} tamamlandı`);\n\n// Tüm kuyruk durumu\nconst allStatus = supsis.queue.status();\nconsole.log(`Toplam: ${allStatus.queueLength} iş bekliyor`);",
                            },
                        ],
                    };
                }

                // report. alt metodları
                const reportMatch = lastWord.match(/^supsis\.report\.?$/);
                console.log("createCompletionItemProvider-> reportMatch", reportMatch);
                if (reportMatch) {
                    return {
                        suggestions: [
                            {
                                label: "sessionOverall",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'sessionOverall({\n  startDate: "${1:2024-06-01}",\n  endDate: "${2:2024-06-30}",\n  users: ["${3:userId1}"],\n  channels: ["${4:channelId1}"],\n  timezone: "${5:Europe/Istanbul}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Session overall raporu döndürür",
                                documentation:
                                    "Belirtilen parametrelerle session overall raporu döndürür. Parametreler: startDate, endDate, users, channels, timezone.",
                            },
                            {
                                label: "ratingOverall",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'ratingOverall({\n  startDate: "${1:2024-06-01}",\n  endDate: "${2:2024-06-30}",\n  users: ["${3:userId1}"],\n  channels: ["${4:channelId1}"],\n  timezone: "${5:Europe/Istanbul}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Rating overall raporu döndürür",
                                documentation:
                                    "Belirtilen parametrelerle rating overall raporu döndürür. Parametreler: startDate, endDate, users, channels, timezone.",
                            },
                            {
                                label: "chatDistributionsAll",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'chatDistributionsAll({\n  startDate: "${1:2024-06-01}",\n  endDate: "${2:2024-06-30}",\n  users: ["${3:userId1}"],\n  channels: ["${4:channelId1}"],\n  timezone: "${5:Europe/Istanbul}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Chat distributions all raporu döndürür",
                                documentation:
                                    "Belirtilen parametrelerle chat distributions all raporu döndürür. Parametreler: startDate, endDate, users, channels, timezone.",
                            },
                            {
                                label: "contactDistributionsAll",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'contactDistributionsAll({\n  startDate: "${1:2024-06-01}",\n  endDate: "${2:2024-06-30}",\n  users: ["${3:userId1}"],\n  channels: ["${4:channelId1}"],\n  timezone: "${5:Europe/Istanbul}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kişi dağılımı raporu döndürür",
                                documentation:
                                    "Belirtilen parametrelerle kişi dağılımı raporu döndürür. Parametreler: startDate, endDate, users, channels, timezone.",
                            },
                            {
                                label: "calendarEvents",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'calendarEvents({\n  startDate: "${1:2024-06-01}",\n  endDate: "${2:2024-06-30}",\n  users: ["${3:userId1}"],\n  channels: ["${4:channelId1}"],\n  timezone: "${5:Europe/Istanbul}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Takvim etkinlikleri raporu döndürür",
                                documentation:
                                    "Belirtilen parametrelerle calendar events raporu döndürür. Parametreler: startDate, endDate, users, channels, timezone.",
                            },
                            {
                                label: "reservationEvents",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'reservationEvents({\n  startDate: "${1:2024-06-01}",\n  endDate: "${2:2024-06-30}",\n  users: ["${3:userId1}"],\n  channels: ["${4:channelId1}"],\n  timezone: "${5:Europe/Istanbul}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Rezervasyon etkinlikleri raporu döndürür",
                                documentation:
                                    "Belirtilen parametrelerle reservation events raporu döndürür. Parametreler: startDate, endDate, users, channels, timezone.",
                            },
                            {
                                label: "ticketDistributionsAll",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'ticketDistributionsAll({\n  startDate: "${1:2024-06-01}",\n  endDate: "${2:2024-06-30}",\n  users: ["${3:userId1}"],\n  channels: ["${4:channelId1}"],\n  timezone: "${5:Europe/Istanbul}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Ticket dağılımı raporu döndürür",
                                documentation:
                                    "Belirtilen parametrelerle ticket distributions all raporu döndürür. Parametreler: startDate, endDate, users, channels, timezone.",
                            },
                            {
                                label: "taskOverall",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'taskOverall({\n  startDate: "${1:2024-06-01}",\n  endDate: "${2:2024-06-30}",\n  users: ["${3:userId1}"],\n  workflowId: "${4:workflowId1}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Görev genel raporu döndürür",
                                documentation:
                                    "Belirtilen parametrelerle task overall raporu döndürür. Parametreler: startDate, endDate, users, workflowId.",
                            },
                            {
                                label: "mailInboxCounts",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'mailInboxCounts({\n  startDate: "${1:2024-06-01}",\n  endDate: "${2:2024-06-30}",\n  users: ["${3:userId1}"],\n  channels: ["${4:channelId1}"],\n  timezone: "${5:Europe/Istanbul}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Mail gelen kutusu sayısı raporu döndürür",
                                documentation:
                                    "Belirtilen parametrelerle mail inbox counts raporu döndürür. Parametreler: startDate, endDate, users, channels, timezone.",
                            },
                            {
                                label: "mailSendCounts",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'mailSendCounts({\n  startDate: "${1:2024-06-01}",\n  endDate: "${2:2024-06-30}",\n  users: ["${3:userId1}"],\n  channels: ["${4:channelId1}"],\n  timezone: "${5:Europe/Istanbul}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Mail gönderim sayısı raporu döndürür",
                                documentation:
                                    "Belirtilen parametrelerle mail send counts raporu döndürür. Parametreler: startDate, endDate, users, channels, timezone.",
                            },
                            {
                                label: "channelOverall",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'channelOverall({\n  startDate: "${1:2024-06-01}",\n  endDate: "${2:2024-06-30}",\n  users: ["${3:userId1}"],\n  channels: ["${4:channelId1}"],\n  timezone: "${5:Europe/Istanbul}",\n  channelType: "${6:whatsapp}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kanal bazlı genel rapor döndürür",
                                documentation:
                                    "Belirtilen parametrelerle channel overall raporu döndürür. Parametreler: startDate, endDate, users, channels, timezone, channelType.",
                            },
                            {
                                label: "walletStatus",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'walletStatus({\n  startDate: "${1:2024-06-01}",\n  endDate: "${2:2024-06-30}",\n  channels: ["${3:channelId1}"],\n  timezone: "${4:Europe/Istanbul}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Cüzdan durumu raporu döndürür",
                                documentation:
                                    "Belirtilen parametrelerle wallet status raporu döndürür. Parametreler: startDate, endDate, channels, timezone.",
                            },
                            {
                                label: "websiteTraffic",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'websiteTraffic({\n  startDate: "${1:2024-06-01}",\n  endDate: "${2:2024-06-30}",\n  timezone: "${3:Europe/Istanbul}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Web sitesi trafiği raporu döndürür",
                                documentation:
                                    "Belirtilen parametrelerle website traffic raporu döndürür. Parametreler: startDate, endDate, timezone.",
                            },
                            {
                                label: "wabaMessageTraffic",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'wabaMessageTraffic({\n  startDate: "${1:2024-06-01}",\n  endDate: "${2:2024-06-30}",\n  channels: ["${3:channelId1}"],\n  timezone: "${4:Europe/Istanbul}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "WABA mesaj trafiği raporu döndürür",
                                documentation:
                                    "Belirtilen parametrelerle waba message traffic raporu döndürür. Parametreler: startDate, endDate, channels, timezone.",
                            },
                            {
                                label: "teamWorkCalendar",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    'teamWorkCalendar({\n  startDate: "${1:2024-06-01}",\n  endDate: "${2:2024-06-30}",\n  users: ["${3:userId1}"],\n  timezone: "${4:Europe/Istanbul}"\n})',
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Takım çalışma takvimi raporu döndürür",
                                documentation:
                                    "Belirtilen parametrelerle team work calendar raporu döndürür. Parametreler: startDate, endDate, users, timezone.",
                            },
                        ],
                    };
                }

                // supsis.module. için hem "list" metodu hem de dinamik modüller
                const modulePrefixMatch = lastWord.match(/^supsis\.module\.?$/);
                if (modulePrefixMatch) {
                    const moduleSuggestions = [
                        {
                            label: "list",
                            kind: monaco.languages.CompletionItemKind.Method,
                            insertText: "list()",
                            detail: "Tüm modülleri listeler",
                            documentation: "Sistemdeki tüm erişilebilir modüllerin listesini döndürür",
                        },
                    ];

                    (moduleCache || []).filter(m => m.type === "module" && m.apiName && _.get(m, "module.settings.apiEnabled", true)).forEach(m => {
                        moduleSuggestions.push({
                            label: m.apiName,
                            kind: monaco.languages.CompletionItemKind.Module,
                            insertText: m.apiName,
                            detail: `${m.displayName || m.moduleName} Modülü`,
                            documentation: `${m.description || "Modül Erişimi"}`
                        });
                    });
                    return { suggestions: moduleSuggestions };
                }

                // Dinamik modüller için metodları göster
                const moduleInstanceMatch = lastWord.match(/^supsis\.module\.([a-zA-Z0-9_]+)\.?$/);
                console.log("createCompletionItemProvider-> moduleInstanceMatch", moduleInstanceMatch);
                if (moduleInstanceMatch) {
                    const moduleApiName = moduleInstanceMatch[1];

                    // list özel bir metod olduğu için kontrol et
                    if (moduleApiName === "list") {
                        return {
                            suggestions: [],
                        };
                    }

                    // Seçilen modülün bilgilerini bul
                    let selectedModule = null;
                    let fieldSnippets = "";

                    try {
                        // Store'dan modülü ve alanlarını bul
                        const modules = store.state.module.modules || [];
                        selectedModule = modules.find((m) => m.apiName === moduleApiName && m.type === "module");

                        if (selectedModule && selectedModule.module && selectedModule.module.table) {
                            const tableFields =
                                store.state.table.tables.find((t) => t._id === selectedModule.module.table)?.fields ||
                                [];

                            // API adı olan alanları snippet için hazırla
                            const fieldsWithApiName = tableFields.filter((field) => field.apiName);

                            if (fieldsWithApiName.length > 0) {
                                fieldSnippets = fieldsWithApiName
                                    .map((field) => `\t${field.apiName}: ${getDefaultValueByType(field.fieldType)}`)
                                    .join(",\n");

                                console.log(`${moduleApiName} modülü için ${fieldsWithApiName.length} alan bulundu.`);
                            }
                        }
                    } catch (error) {
                        console.error(`Modül alanları alınırken hata:`, error);
                    }

                    // Alan snippet'i oluşturulamadıysa varsayılanı kullan
                    if (!fieldSnippets) {
                        fieldSnippets = "\t${1:field}: ${2:value}";
                    }

                    return {
                        suggestions: [
                            {
                                label: "get",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "get(${1:id})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kayıt getirir",
                                documentation: `${moduleApiName} modülünden ID'ye göre kayıt getirir`,
                            },
                            {
                                label: "create",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: `create({\n${fieldSnippets}\n})`,
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Yeni kayıt oluşturur",
                                documentation: `${moduleApiName} modülüne yeni kayıt ekler`,
                            },
                            {
                                label: "update",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: `update(\${1:id}, {\n${fieldSnippets}\n})`,
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kayıt günceller",
                                documentation: `${moduleApiName} modülündeki bir kaydı günceller`,
                            },
                            {
                                label: "delete",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: `delete(\${1:id})`,
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kayıt siler",
                                documentation: `${moduleApiName} modülündeki bir kaydı siler`,
                            },
                            {
                                label: "search",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    "search({\n\tfilters: ${1:[]},\n\tsort: ${2:{}},\n\tcursor: ${3:{ page: 1, perPage: 20 }}\n})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Kayıtları filtreler ve arar",
                                documentation: `${moduleApiName} modülündeki kayıtları filtreler ve listeler`,
                            },
                        ],
                    };
                }

                // Üçüncü seviye tamamlamalar için - get metodu sonrası
                const thirdLevelMatch = lastWord.match(
                    /^supsis\.(users|ticket|task|contact|whatsapp|chat|message|sms|email|report|module\.[a-zA-Z0-9_]+)\.(get|list|create|update|search)\.?$/
                );
                if (thirdLevelMatch) {
                    // Metod çağrısı sonrası tamamlamalar için basit öneriler
                    return {
                        suggestions: [
                            {
                                label: "then",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText: "then(function(result) {\n\t${1:// İşlem başarılı}\n\treturn result;\n})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Promise başarı işleyicisi",
                                documentation: "İşlem başarılı olduğunda çalışacak fonksiyon",
                            },
                            {
                                label: "catch",
                                kind: monaco.languages.CompletionItemKind.Method,
                                insertText:
                                    "catch(function(error) {\n\t${1:// Hata oluştu}\n\tconsole.error(error);\n})",
                                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                                detail: "Promise hata işleyicisi",
                                documentation: "İşlemde hata oluştuğunda çalışacak fonksiyon",
                            },
                        ],
                    };
                }
            }

            // task.readAttribute içerisinde çağrılan context'leri tamamla
            const taskReadAttributeMatch = textUntilPosition.match(/task\.readAttribute\s*\(\s*['"]([a-zA-Z\d.]*)$/);
            if (taskReadAttributeMatch) {
                const prefix = taskReadAttributeMatch[1];
                const contextMatch = prefix.match(/^([a-zA-Z]+)\./);

                if (contextMatch) {
                    const context = contextMatch[1];

                    // Tekrarlanan önerileri filtreleme
                    const uniqueSuggestions = [];
                    const valueSet = new Set();

                    flatAttributes
                        .filter((attr) => attr.context === context && attr.value.startsWith(prefix))
                        .forEach((attr) => {
                            // Eğer bu değer daha önce eklenmemişse ekle
                            if (!valueSet.has(attr.value)) {
                                valueSet.add(attr.value);
                                uniqueSuggestions.push({
                                    label: attr.fullLabel || attr.value,
                                    kind: monaco.languages.CompletionItemKind.Variable,
                                    insertText: attr.value,
                                    detail: attr.value,
                                    documentation: `${attr.fullLabel || attr.value}\nTip: ${
                                        attr.valueType || "string"
                                    }`,
                                });
                            }
                        });

                    return {
                        suggestions: uniqueSuggestions,
                    };
                } else {
                    // Ana context'leri öner
                    return {
                        suggestions: [
                            { label: "block", insertText: "block.", kind: monaco.languages.CompletionItemKind.Folder },
                            { label: "event", insertText: "event.", kind: monaco.languages.CompletionItemKind.Folder },
                            {
                                label: "system",
                                insertText: "system.",
                                kind: monaco.languages.CompletionItemKind.Folder,
                            },
                            {
                                label: "webhook",
                                insertText: "webhook.",
                                kind: monaco.languages.CompletionItemKind.Folder,
                            },
                            {
                                label: "custom",
                                insertText: "custom.",
                                kind: monaco.languages.CompletionItemKind.Folder,
                            },
                        ],
                    };
                }
            }

            // Kütüphane metod ve fonksiyonları için öneriler (tekrarsız)
            const suggestions = [];
            const suggestionSet = new Set(); // Duplicate önleme için

            // Moment kütüphanesi için öneriler
            if (textUntilPosition.indexOf("moment") !== -1) {
                const momentSuggestions = [
                    {
                        label: "format",
                        kind: monaco.languages.CompletionItemKind.Method,
                        insertText: "format('${1:YYYY-MM-DD HH:mm:ss}')",
                        insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                        documentation: "Tarihi belirtilen formatta biçimlendirir",
                    },
                    {
                        label: "add",
                        kind: monaco.languages.CompletionItemKind.Method,
                        insertText: "add(${1:1}, '${2:days}')",
                        insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                        documentation: "Tarih/zamana değer ekler",
                    },
                ];

                momentSuggestions.forEach((suggestion) => {
                    if (!suggestionSet.has(suggestion.label)) {
                        suggestionSet.add(suggestion.label);
                        suggestions.push(suggestion);
                    }
                });
            }

            // Lodash kütüphanesi için öneriler
            if (textUntilPosition.indexOf("_") !== -1) {
                const lodashSuggestions = [
                    {
                        label: "get",
                        kind: monaco.languages.CompletionItemKind.Method,
                        insertText: "get(${1:object}, '${2:path}', ${3:defaultValue})",
                        insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                        documentation: "Nesne içindeki değeri yol kullanarak alır",
                    },
                    {
                        label: "filter",
                        kind: monaco.languages.CompletionItemKind.Method,
                        insertText: "filter(${1:array}, function(item) {\n\treturn ${2:condition};\n})",
                        insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                        documentation: "Dizi elemanlarını filtrelemek için kullanılır",
                    },
                    {
                        label: "map",
                        kind: monaco.languages.CompletionItemKind.Method,
                        insertText: "map(${1:array}, function(item) {\n\treturn ${2:item};\n})",
                        insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                        documentation: "Dizi elemanlarını dönüştürmek için kullanılır",
                    },
                ];

                lodashSuggestions.forEach((suggestion) => {
                    if (!suggestionSet.has(suggestion.label)) {
                        suggestionSet.add(suggestion.label);
                        suggestions.push(suggestion);
                    }
                });
            }

            // Axios kütüphanesi için öneriler
            if (textUntilPosition.indexOf("axios") !== -1) {
                const axiosSuggestions = [
                    {
                        label: "get",
                        kind: monaco.languages.CompletionItemKind.Method,
                        insertText: "get('${1:url}', ${2:config})",
                        insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                        documentation: "HTTP GET isteği yapar",
                    },
                    {
                        label: "post",
                        kind: monaco.languages.CompletionItemKind.Method,
                        insertText: "post('${1:url}', ${2:data}, ${3:config})",
                        insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                        documentation: "HTTP POST isteği yapar",
                    },
                ];

                axiosSuggestions.forEach((suggestion) => {
                    if (!suggestionSet.has(suggestion.label)) {
                        suggestionSet.add(suggestion.label);
                        suggestions.push(suggestion);
                    }
                });
            }

            // Task API için öneriler
            if (textUntilPosition.indexOf("task") !== -1) {
                const taskSuggestions = [
                    {
                        label: "readAttribute",
                        kind: monaco.languages.CompletionItemKind.Method,
                        insertText: "readAttribute('${1:attribute}', ${2:defaultValue})",
                        insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                        documentation: "Sisteme tanımlı bir değeri okur",
                    },
                    {
                        label: "bindAttribute",
                        kind: monaco.languages.CompletionItemKind.Method,
                        insertText: "bindAttribute(${1:data})",
                        insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                        documentation: "Veriyi değişkenlerle işler",
                    },
                ];

                taskSuggestions.forEach((suggestion) => {
                    if (!suggestionSet.has(suggestion.label)) {
                        suggestionSet.add(suggestion.label);
                        suggestions.push(suggestion);
                    }
                });
            }

            // supsis ana obje için
            if (textUntilPosition.match(/[\s\(\[{]supsis$/)) {
                suggestions.push({
                    label: "supsis",
                    kind: monaco.languages.CompletionItemKind.Variable,
                    insertText: "supsis",
                    detail: "Supsis SDK",
                    documentation: "Supsis platformu veri erişim SDK'sı",
                });
            }

            return {
                suggestions: suggestions,
            };
        },
        triggerCharacters: [".", "$", "*", "[", "b", "c", "e", "s", "w"],
    };
};

// Field türüne göre varsayılan değer önerileri oluşturmak için yardımcı fonksiyon
const getDefaultValueByType = (fieldType) => {
    switch (fieldType) {
        case "text":
        case "long-text":
        case "email":
        case "phone":
        case "url":
        case "color":
            return '"${1:value}"';
        case "number":
        case "currency":
            return "${1:0}";
        case "datetime":
            return "new Date()";
        case "checkbox":
            return "${1:false}";
        case "dropdown":
            return '"${1:option}"';
        case "json":
            return '{ ${1:key}: "${2:value}" }';
        default:
            return "${1:null}";
    }
};
